import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import CloseIcon from "@mui/icons-material/Close";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import EditIcon from "@mui/icons-material/Edit";
import PrintIcon from "@mui/icons-material/Print";
import WifiProtectedSetupIcon from "@mui/icons-material/WifiProtectedSetup";
import {
  Box,
  Button,
  Container,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { uniq } from "lodash";
import moment from "moment";
import { useEffect, useLayoutEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import CustomButton from "../../../../components/CustomButton";
import { default as Checkbox } from "../../../../components/CustomCheckbox";
import CustomModal from "../../../../components/CustomModal/CustomModal";
import CustomSwitch from "../../../../components/CustomSwitch";
import CustomTextField from "../../../../components/CustomTextField";
import SearchableSelect from "../../../../components/Select/SearchableSelect";
import { default as CustomSelect } from "../../../../components/Select/Select";
import {
  addBillingItemsToPaymentId,
  applyTotalDiscountByPayAndDetailId,
  checkoutBillingByPaymentId,
  checkoutDirectBilling,
  deleteBillingPaymentById,
  deletePaymentItemById,
  getAllDiscountCodes,
  getBillDetailsByPaymentId,
  getPaymentErrorLogs,
  payAmountByPaymentId,
  setBillDetails,
  updateBillCheckDetails,
  updateBillingByPaymentId,
  updateBillingItemsByPaymentId,
  updateClinicUserCollectionRefund,
  updateDiscountCodeById,
  updatePayment,
  updatePaymentTypeById,
} from "../../../../redux/reducers/clinicSlice";
import { updateMultiCollectionStatusAndInvoiceNo } from "../../../../redux/reducers/paymentSlice";
import { getPetAndAppointmentDetailsById } from "../../../../redux/reducers/petSlice";
import { showSnackBar } from "../../../../redux/reducers/snackSlice";
import { AppColors } from "../../../../util/AppColors";
import {
  dropDiscountTypes,
  radioDiscountTypes,
  rolesForBilling,
  rolesToCreateInventory,
} from "../../../../util/arrayList";
import {
  delBtn,
  w15h15BlueIcon,
  w20h20BlueIcon,
  w20h20GreenIcon,
} from "../../../../util/CommonIconStyle";
import {
  billAsForBillingHistory,
  discountTypes,
} from "../../../../util/dropList";
import {
  billingTabEnum,
  checkoutEnum,
  payTabEnum,
} from "../../../../util/enum";
import {
  refreshMandateStocks,
  refreshMandateStocksAndServices,
} from "../../../../util/fetchAndStoreMandate";
import {
  allocateExactFlatDiscountPerUnit,
  getDiscountCodeAvailableToday,
  getPetShopRecordBasedType,
  getPharmacyRecordBasedType,
  getPrevDiscountValues,
  getRightPackageUom,
  getTaxAndSubTotalAndTotal,
  getTreatmentRecordBasedType,
  removeDuplicateBracketText,
  reorderList,
  roundWithSignedDiff,
} from "../../../../util/function";
import { tblGrayBack } from "../../../../util/object";
import { flattenPaymentErrorLogs } from "../../../../util/paymentChangeLog";
import CommonPayModal from "../../../CommonComponents/CommonPayModal";
import BillingPreview from "../../../CommonScreens/BillingPreview/BillingPreview";
import CollectDeposit from "../../../CommonScreens/Payments/CollectDeposit";
import "./Billing.css";

const phrTblHdrs = [
  "serviceitemname",
  "qty",
  "unitPrice",
  "discount",
  "tax",
  "total",
  "pay",
];

const tableNameExpan = {
  serviceitemname: "Service/Item Name",
  qty: "Qty",
  unitPrice: "Unit Price",
  tax: "Tax",
  adminCharge: "Admin Charge",
  total: "Item Total",
  days: "Days",
  discount: "Unit Discount",
};

const initialValues = {
  quantity: 1,
  price: 0,
  unitType: "Unit",
  discountType: discountTypes?.[0],
  linkToProcedure: null,
};
const initialPayValues = {
  amount: "",
  paymentMode: { name: "Cash", value: "cash" },
};
const initDis = { type: "code", amt: "", discountCode: null };
const initialPayments = {
  subTotal: 0,
  tax: "-",
  discount: 0,
  amtPaid: 0,
  balDue: 0,
};
const initShows = { showSublineItems: true, showSublinePrice: true };
const initBilledBy = {
  billedBy: null,
  error: false,
  pharmacyBilledBy: null,
  pharmacyError: false,
  petShopBilledBy: null,
  petShopError: false,
  vet: null,
  vetError: false,
};
const defObj = {
  clinic: {},
  vets: [],
  dataSharing: {},
  services: [],
  stocks: [],
  facilities: [],
  locations: [],
  bins: [],
};

const roundAmount = (value) => Number(Number(value ?? 0).toFixed(2));

const Billing = ({ bill, setSelectedBill, setEditBill }) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const initializedTabKeyRef = useRef(null);
  const [activeTab, setActiveTab] = useState("Treatment");
  const [selectedItem, setSelectedItem] = useState(null);
  const [editModVsble, setEditModVsble] = useState(false);
  const [disValues, setDisValues] = useState(initDis);
  const [genBillModVsble, setGenBillModVsble] = useState(false);
  const [disErrs, setDisErrs] = useState({});
  const [searchVisible, setSearchVisible] = useState(false);
  const [searchOverlayStyle, setSearchOverlayStyle] = useState(null);
  const searchAnchorRef = useRef(null);
  const billingScrollRef = useRef(null);
  const [depositVsble, setDepositVsble] = useState(false);
  const [editVisible, setEditVisible] = useState(false);
  const [disModVsble, setDisModVsble] = useState(false);
  const [delModVisible, setDelModVisible] = useState(false);
  const [paymentDetails, setPaymentDetails] = useState(initialPayments);
  const [searchValue, setSearchValue] = useState("");
  const [mandateSessionTick, setMandateSessionTick] = useState(0);
  const [itemValues, setItemValues] = useState(initialValues);
  const [addModVsble, setAddModVsble] = useState(false);
  const [queuedAddItems, setQueuedAddItems] = useState([]);
  const [addItemErrs, setAddItemErrs] = useState({});
  const [isAddingItems, setIsAddingItems] = useState(false);
  const addingItemsRef = useRef(false);
  const [billedByValues, setBilledByValues] = useState(initBilledBy);
  const [billRemarks, setBillRemarks] = useState("");
  const [prntPrevVsble, setPrntPrevVsble] = useState(false);
  const [payModalVisible, setPayModalVisible] = useState(false);
  const [payValues, setPayValues] = useState(initialPayValues);
  const [payErr, setPayErr] = useState({});
  const [totalBalanceDue, setTotalBalanceDue] = useState(0);
  const [showValues, setShowValues] = useState(initShows);
  const [switchValues, setSwitchValues] = useState({ visible: false });
  const [paymentChangeLogs, setPaymentChangeLogs] = useState([]);
  const appDet = useSelector((state) => state?.pet?.complaintSummary?.data);
  const petAndApntData = useSelector(
    (state) => state?.pet?.petAndAppointmentDetails,
  );
  const {
    billDetails,
    discountCodes,
    petBilling,
    details: clinicDetail,
  } = useSelector((state) => state?.clinic);
  const lastSummary = useSelector((state) => state?.pet?.lastSummary?.data);
  const petDet = appDet?.pet;
  const apnt = appDet?.appointment;
  const user = localStorage.getItem("user");
  const profile = JSON.parse(user);
  const role = localStorage.getItem("role");
  const allRoles = (() => {
    try {
      const parsed = JSON.parse(localStorage.getItem("allRoles"));
      if (Array.isArray(parsed)) return parsed.filter(Boolean);
      return parsed ? [parsed] : [];
    } catch {
      return [];
    }
  })();
  const mandateDataRaw = sessionStorage.getItem("mandateData");
  const {
    clinic: clinicData,
    vets: clinicVetList,
    dataSharing,
    services,
    stocks,
    locations,
  } = useMemo(() => {
    if (!mandateDataRaw) return defObj;
    try {
      const reqData = JSON.parse(mandateDataRaw);
      return {
        clinic: reqData?.clinic ?? {},
        vets: Array.isArray(reqData?.vets) ? reqData?.vets : [],
        dataSharing: reqData?.dataSharing ?? {},
        services: Array.isArray(reqData?.services) ? reqData?.services : [],
        stocks: Array.isArray(reqData?.stocks) ? reqData?.stocks : [],
        facilities: Array.isArray(reqData?.facilities)
          ? reqData?.facilities
          : [],
        locations: Array.isArray(reqData?.locations) ? reqData?.locations : [],
        bins: Array.isArray(reqData?.bins) ? reqData?.bins : [],
      };
    } catch {
      return defObj;
    }
  }, [mandateDataRaw, mandateSessionTick]);
  const clinicVets = clinicVetList ?? [];
  const clinicDet = clinicData;
  const clinicForLog = clinicDetail?.id ? clinicDetail : clinicDet;
  const isBillSeparated =
    (clinicDet?.billingMode ?? "")?.toLowerCase() === "separate";
  const treatTabList = getTreatmentRecordBasedType(
    billDetails?.paymentDetails ?? [],
  );
  const pharTabList = getPharmacyRecordBasedType(
    billDetails?.paymentDetails ?? [],
  );
  const petShopTabList = getPetShopRecordBasedType(
    billDetails?.paymentDetails ?? [],
  );
  const amtPaidByTab = {
    Treatment: roundWithSignedDiff(billDetails?.amtPaid ?? 0)?.rounded,
    Pharmacy: roundWithSignedDiff(billDetails?.amtPaid ?? 0)?.rounded,
    "Pet Shop": roundWithSignedDiff(billDetails?.amtPaid ?? 0)?.rounded,
  };
  const totalByTab = {
    Treatment: roundWithSignedDiff(billDetails?.totalAmt ?? 0)?.rounded,
    Pharmacy: roundWithSignedDiff(billDetails?.totalAmt ?? 0)?.rounded,
    "Pet Shop": roundWithSignedDiff(billDetails?.totalAmt ?? 0)?.rounded,
  };
  // Prefer bill prop so stale Redux billDetails cannot drive the wrong fetch
  const reqPaymentId =
    bill?.paymentId ?? billDetails?.paymentId ?? petDet?.paymentId;
  // Single derived id so petDet loading later does not re-fetch the same bill
  const fetchPaymentId = bill?.paymentId ?? petDet?.paymentId;
  const paymentId = billDetails?.paymentId ?? bill?.paymentId;

  const refreshStocksAfterStockAction = (isStockAction = false) => {
    if (!isStockAction) return;
    refreshMandateStocks(dispatch).then(() => {
      setMandateSessionTick((tick) => tick + 1);
    });
  };

  useEffect(() => {
    if (!fetchPaymentId) return;
    dispatch(getBillDetailsByPaymentId(fetchPaymentId)).then((res) => {
      if (res?.payload) {
        const url = "";
        getDiscountCodeList(url);
        refreshMandateStocksAndServices(dispatch).then(() => {
          setMandateSessionTick((tick) => tick + 1);
        });
      }
    });
  }, [fetchPaymentId]);

  useEffect(() => {
    if (!fetchPaymentId) {
      setPaymentChangeLogs([]);
      return;
    }
    dispatch(getPaymentErrorLogs(fetchPaymentId)).then((res) => {
      setPaymentChangeLogs(Array.isArray(res?.payload) ? res.payload : []);
    });
  }, [fetchPaymentId, dispatch]);

  useEffect(() => {
    return () => {
      dispatch(setBillDetails(null));
      setPaymentChangeLogs([]);
    };
  }, [dispatch]);

  const closingTime = useMemo(() => {
    if (billDetails?.checkoutTime) return billDetails.checkoutTime;

    const billApptId = billDetails?.appointmentId;
    if (!billApptId) return null;

    const billApptIdStr = String(billApptId);

    if (
      String(appDet?.appointment?.appointmentId) === billApptIdStr &&
      appDet?.appointment?.checkoutTime
    ) {
      return appDet.appointment.checkoutTime;
    }

    return null;
  }, [
    billDetails?.checkoutTime,
    billDetails?.appointmentId,
    appDet?.appointment?.appointmentId,
    appDet?.appointment?.checkoutTime,
    lastSummary?.appointment?.appointmentId,
    lastSummary?.appointment?.checkoutTime,
  ]);

  const paymentLogRows = useMemo(
    () =>
      flattenPaymentErrorLogs(
        paymentChangeLogs,
        clinicVets,
        clinicForLog,
        billDetails,
        closingTime,
      ),
    [paymentChangeLogs, clinicVets, clinicForLog, billDetails, closingTime],
  );
  useLayoutEffect(() => {
    if (!searchVisible) {
      setSearchOverlayStyle(null);
      return undefined;
    }
    const updateOverlayStyle = () => {
      const scrollEl = billingScrollRef.current;
      if (!scrollEl) return;
      const scrollRect = scrollEl.getBoundingClientRect();
      const height = window.innerHeight * 0.65;
      setSearchOverlayStyle({
        top: window.innerHeight - height,
        left: scrollRect.left,
        width: scrollRect.width,
        height,
      });
    };
    updateOverlayStyle();
    window.addEventListener("resize", updateOverlayStyle);
    const scrollEl = billingScrollRef.current;
    scrollEl?.addEventListener("scroll", updateOverlayStyle);
    return () => {
      window.removeEventListener("resize", updateOverlayStyle);
      scrollEl?.removeEventListener("scroll", updateOverlayStyle);
    };
  }, [searchVisible]);

  const closeSearchOverlay = () => {
    setSearchVisible(false);
    setSearchValue("");
  };

  useEffect(() => {
    getPaymentDetails();
    setShowValues({
      showSublineItems: billDetails?.showSublineItems,
      showSublinePrice: billDetails?.showSublinePrice,
    });
    const isReopenedInvc =
      ["N", "n"].includes(billDetails?.checkOut) &&
      (billDetails?.treatmentInvoiceNumber ?? "")?.startsWith("INV");
    if (
      isReopenedInvc ||
      ((billDetails?.type === "Treatment" ||
        billDetails?.type === "Pharmacy" ||
        billDetails?.type === "Pet Shop" ||
        (billDetails?.type === "Clinic" &&
          !billDetails?.estimate &&
          !billDetails?.appointmentId) ||
        (billDetails?.appointmentType === "Virtual"
          ? billDetails?.appointmentStatus?.toLowerCase() === "inprogress"
          : billDetails?.appointmentStatus?.toLowerCase() === "finalize")) &&
        billDetails?.checkOut !== "Y" &&
        !(
          Array.isArray(allRoles) && allRoles.length > 0
            ? allRoles
            : [profile?.role || role].filter(Boolean)
        ).some((r) => rolesToCreateInventory.includes(r)))
    ) {
      const reqObj = {
        billedBy: {
          name: billDetails?.billedByName ?? profile?.name,
          value: billDetails?.billedById ?? profile?.id,
        },
        error: false,
        pharmacyBilledBy: {
          name: billDetails?.billedByName ?? profile?.name,
          value: billDetails?.billedById ?? profile?.id,
        },
        pharmacyError: false,
        petShopBilledBy: {
          name: billDetails?.billedByName ?? profile?.name,
          value: billDetails?.billedById ?? profile?.id,
        },
        petShopError: false,
        vet: null,
        vetError: false,
      };
      if (billDetails?.type === "Pharmacy" && billDetails?.doctorId) {
        reqObj.vet = {
          name: billDetails?.doctorName,
          value: billDetails?.doctorId,
        };
      }
      setBilledByValues(reqObj);
    }
    setBillRemarks(billDetails?.billRemarks ?? "");
    if (billDetails?.type === "Clinic") return;
    if (
      billDetails?.type !== "Clinic" &&
      (billDetails?.type === "Treatment" ||
        billDetails?.type === "Pharmacy" ||
        billDetails?.type === "Pet Shop")
    ) {
      const currentTabKey = `${billDetails?.paymentId ?? ""}-${billDetails?.type}`;
      if (initializedTabKeyRef.current !== currentTabKey) {
        initializedTabKeyRef.current = currentTabKey;
        setActiveTab(billDetails?.type);
      }
    }
  }, [billDetails]);

  const getTabBasedRecords = () => {
    return activeTab === "Treatment"
      ? treatTabList
      : activeTab === "Pet Shop"
        ? petShopTabList
        : pharTabList;
  };

  const getDiscountCodeList = (url = "") => {
    dispatch(getAllDiscountCodes(url));
  };

  const getUnitPriceAndTotalForService = (itm) => {
    const li = itm;
    let reqList = [];
    if (li?.serviceId && li?.variantId && !li?.patientWorkbook) {
      const reqServ = services?.find((ser) => ser?.serviceId === li?.serviceId);
      const reqVarnt = reqServ?.serviceVariants?.find(
        (vnt) => vnt?.variantId === li?.variantId,
      );
      if (reqVarnt?.serviceDetails?.length > 0) {
        const filteredDetails =
          reqVarnt?.serviceDetails?.filter(
            (lit) =>
              (lit?.alterType === "N" && !lit?.alterName) ||
              (lit?.alterType === "Y" && !lit?.alterName),
          ) || [];

        filteredDetails.forEach((lit) => {
          // Check if item already exists to prevent duplicates
          const existingItem = reqList.find(
            (item) =>
              item?.serviceId === lit?.serviceId &&
              item?.variantId === lit?.variantId &&
              item?.name === lit?.name,
          );

          if (!existingItem) {
            reqList.push({
              ...lit,
              estCost: lit?.estimatedCost,
              serviceId: lit?.serviceId,
              variantId: lit?.variantId,
              serviceCharge: reqVarnt?.serviceCharge ?? 0,
            });
          }
        });
      }
      if (reqVarnt?.servicePrescreiptions?.length > 0) {
        const filteredPrescriptions =
          reqVarnt?.servicePrescreiptions?.filter(
            (lit) =>
              (lit?.alterType === "N" && !lit?.alterName) ||
              (lit?.alterType === "Y" && !lit?.alterName),
          ) || [];

        filteredPrescriptions.forEach((lit, i) => {
          // Check if item already exists to prevent duplicates
          const existingItem = reqList.find(
            (item) =>
              item?.serviceId === li?.serviceId &&
              item?.variantId === li?.variantId &&
              item?.name === lit?.name,
          );

          if (!existingItem) {
            const admnObj = {
              ...lit,
              estCost: lit?.estimatedCost ?? 0,
              serviceId: li?.serviceId,
              variantId: li?.variantId,
              serviceCharge: reqVarnt?.serviceCharge ?? 0,
            };
            reqList.push(admnObj);
          }
        });
      }

      reqList = reqList
        ?.map((lit) => ({
          ...lit,
          subItemName: lit?.name,
          serviceitemname: lit?.name,
          qty: lit?.quantity,
          unitPrice: lit?.estimatedCost ?? lit?.estCost,
          discount: 0,
          adminCharge: 0,
          total: lit?.estimatedCost ?? lit?.estCost,
        }))
        // Remove duplicates from reqList
        .filter(
          (item, index, self) =>
            index ===
            self.findIndex(
              (reqItem) =>
                reqItem.subItemName === item.subItemName &&
                reqItem.serviceId === item.serviceId &&
                reqItem.variantId === item.variantId,
            ),
        );
    } else {
      if (li?.serviceId) {
        const reqSer = lastSummary?.procedures?.find(
          (pl) => pl?.serviceId === li?.serviceId,
        );
        const reqActSer = services?.find(
          (ser) => ser?.serviceId === li?.serviceId,
        );
        const reqVar = reqActSer?.serviceVariants?.find(
          (vnt) => vnt?.variantId === li?.variantId,
        );
        if (reqSer?.procedureDetails?.length > 0) {
          reqList = reqSer?.procedureDetails?.map((lit) => ({
            ...lit,
            subItemName: lit?.procedureName,
            serviceitemname: lit?.procedureName,
            qty: lit?.quantity,
            unitPrice: lit?.estimatedCost,
            discount: 0,
            adminCharge: 0,
            total: lit?.estimatedCost,
            serviceCharge: reqVar?.serviceCharge ?? 0,
          }));
        }
      }
    }
    const reqTotal =
      activeTab === "Treatment"
        ? reqList?.length > 0
          ? Number(
              reqList
                ?.filter((rl) => (li?.variantId ? true : rl?.status === "true"))
                ?.reduce((acc, rl) => acc + Number(rl?.total), 0) +
                Number(reqList?.[0]?.serviceCharge ?? 0),
            ) - Number(li?.mrpDiscount ?? 0)
          : li?.total
        : li?.total;
    return {
      total: reqTotal,
      unitPrice: Number(reqList?.[0]?.serviceCharge ?? 0),
      totalWithoutDiscount: reqTotal + Number(li?.mrpDiscount ?? 0),
      reqList,
    };
  };

  const getUsedDiscountCodes = () => {
    if (billDetails?.treatmentDiscountId?.length > 0) {
      const reqList = billDetails?.treatmentDiscountId
        ?.map((li) => {
          const match = discountCodes?.find(
            (dc) => dc?.billId?.toString() === li,
          );
          return match;
        })
        ?.filter(Boolean); // remove undefined if no match found
      return reqList;
    }
    return [];
  };

  const getAutoDiscountCodes = () => {
    return discountCodes?.filter(
      (dc) => dc?.discountMethod === "Automatic discount",
    );
  };

  const getPaymentDetails = () => {
    let subTotal = 0,
      tax = 0,
      discount = 0,
      balDue = 0;
    if (billDetails?.paymentDetails?.length > 0) {
      billDetails?.paymentDetails?.forEach((pd) => {
        tax = tax + Number(pd?.tax) ?? 0;
        subTotal = subTotal + pd?.total;
      });
    }
    if (disValues?.type && Number(disValues?.amt) > 0) {
      if (disValues?.type?.toLowerCase() === "price") {
        discount = Number(disValues?.amt);
      }
      if (disValues?.type?.toLowerCase() === "percentage") {
        discount = (subTotal / 100) * Number(disValues?.amt);
      }
    }
    balDue = subTotal - (discount + billDetails?.amtPaid);
    setPaymentDetails({ ...paymentDetails, subTotal, tax, discount, balDue });
  };

  const handleDelete = (bill) => {
    setSelectedItem({ ...bill, deleteType: "item", actionType: "delete" });
    setDelModVisible(true);
  };

  const handleDelConfirm = () => {
    if (selectedItem?.paymentDetailId) {
      const isStockAction = !!selectedItem?.stockId;
      dispatch(deletePaymentItemById(selectedItem?.paymentDetailId)).then(
        (res) => {
          if (res?.payload) {
            handleUpdatePaymentValues();
            refreshStocksAfterStockAction(isStockAction);
            setSelectedItem(null);
            setDelModVisible(false);
          }
        },
      );
    } else {
      dispatch(
        deleteBillingPaymentById(billDetails?.paymentId ?? bill?.paymentId),
      ).then((res) => {
        if (res?.payload) {
          setDelModVisible(false);
          setSelectedBill(null);
          setEditBill(false);
        }
      });
    }
  };

  const handleEdit = (bill) => {
    const reqStck = stocks?.find((stc) => stc?.stockId === bill?.stockId);
    const reqBat = reqStck?.stockBatch?.find(
      (btch) => btch?.batchId === bill?.batchId,
    );
    const reqUnitPrice = Number(Number(bill?.price ?? 0));
    const reqObj = {
      ...itemValues,
      ...bill,
      name: bill?.name,
      quantity: bill?.quantity,
      price: Number(bill?.mrpPrice ?? bill?.price)?.toFixed(2),
      tax: bill?.tax,
      serviceId: bill?.serviceId ?? null,
      productId: bill?.productId ?? null,
      unitType: bill?.subUnit ?? "Unit",
      adminCharge: "N",
      adminChargeAmount: 0,
      paymentDetailId: bill?.paymentDetailId,
      discount: bill?.mrpDiscount ?? bill?.discount,
      discountType:
        bill?.discountType === "pe" ? discountTypes?.[0] : discountTypes?.[1],
      stockId: bill?.stockId,
      batchId: bill?.batchId,
      batchNumber: reqBat
        ? {
            name: reqBat?.batchNo,
            value: reqBat?.batchId,
            batchId: reqBat?.batchId,
          }
        : null,
      variantNumber: bill?.variantNumber,
      variantId: bill?.variantId,
      type: bill?.type,
      hsnSacCode: bill?.hsnSacCode ?? null,
      drugSchedule: bill?.drugSchedule ?? null,
      packageUom: bill?.packageUom ?? null,
      expiryDate: bill?.expiryDate ?? null,
      batchNo: bill?.batchNo ?? null,
      autoConsumed: bill?.autoConsumed ?? false,
      shortName: bill?.shortName ?? null,
      diagonisticId: bill?.diagonisticId ?? null,
    };
    if (bill?.stockId) {
      const reqUomList = getUOMListByStockId(bill?.stockId);
      const matUom = reqUomList?.find(
        (ul) => ul?.uomMappingId === bill?.uomId || ul?.value === bill?.uomName,
      );
      reqObj.uom = bill?.uomName?.length > 0 || bill?.uomId ? matUom : null;
      if (activeTab === "Treatment") {
        reqObj.linkToProcedure = null;
        if (bill?.procedureId && bill?.linked !== "N") {
          const reqProced = getProcedureList()?.find(
            (li) => li?.apiValue === bill?.procedureId,
          );
          reqObj.linkToProcedure = reqProced ?? null;
        }
      }
    }
    if (bill?.discountType) {
      reqObj.discountType =
        bill?.discountType === "pe"
          ? dropDiscountTypes?.[1]
          : dropDiscountTypes?.[2];
      if (bill?.discountType === "pe") {
        const reqPercent =
          (Number(bill?.mrpDiscount ?? bill?.discount) / Number(reqUnitPrice)) *
          100;
        reqObj.discountValue = Number(reqPercent)?.toFixed(2);
      } else {
        // Already-applied price discount: keep row line total, show per-unit split
        // e.g. unit 617.65 × qty 2 → line 1235.3 → field shows 617.65
        const unitDisc = Number(bill?.mrpDiscount ?? bill?.discount ?? 0);
        const qty = Number(bill?.quantity ?? 1) || 1;
        const lineDisc = roundAmount(unitDisc * qty);
        reqObj.appliedLineDiscount = lineDisc;
        reqObj.discountValue = unitDisc
          ? roundAmount(
              allocateExactFlatDiscountPerUnit(
                [{ price: Number(reqUnitPrice) || 1, quantity: qty }],
                lineDisc,
              )?.[0] ?? unitDisc,
            )?.toFixed(2)
          : 0;
      }
    } else {
      reqObj.discountType = dropDiscountTypes?.[2];
      reqObj.discountValue = 0;
    }
    setItemValues(reqObj);
    setSelectedItem(bill);
    setEditVisible(false);
    setEditModVsble(true);
  };

  const onDiscountModClose = () => {
    setDisModVsble(false);
    setDisErrs({});
    setDisValues(initDis);
  };

  const onChangeDiscount = (name, value) => {
    const errs = {};
    setDisValues({ ...disValues, [name]: value });
    if (name === "amt") {
      errs.amt =
        value?.length > 0
          ? Number(value) > 0
            ? ""
            : "Value must be positive"
          : "This field is required";
    }
    setDisErrs(errs);
  };

  const onChangeItemValue = (name, value, addObj) => {
    const reqObj = { ...itemValues, [name]: value };
    if (name === "batchNumber") {
      reqObj.batchId =
        value?.batchId ?? addObj?.batchId ?? value?.value ?? null;
      reqObj.batchErr = false;
      if (addItemErrs?.batchNumber) {
        setAddItemErrs((prev) => ({ ...prev, batchNumber: "" }));
      }
      if (addModVsble) {
        const allowedUoms = getAddedBatchUomList(
          reqObj?.stockId,
          reqObj?.batchId,
        );
        const currentUomAllowed = allowedUoms?.some(
          (ul) =>
            String(ul?.uomMappingId ?? "") ===
              String(reqObj?.uom?.uomMappingId ?? "") ||
            ul?.value === reqObj?.uom?.value ||
            ul?.value === reqObj?.uom?.name,
        );
        if (allowedUoms?.length > 0 && !currentUomAllowed) {
          reqObj.uom = allowedUoms[0];
        }
      }
    }
    if (
      (name === "uom" || name === "batchNumber") &&
      reqObj?.stockId &&
      !reqObj?.autoConsumed &&
      !(activeTab === "Treatment" && reqObj?.linkToProcedure?.apiValue)
    ) {
      const batchId =
        reqObj?.batchNumber?.batchId ??
        reqObj?.batchNumber?.value ??
        reqObj?.batchId;
      const reqStock = asArray(stocks).find(
        (stc) => String(stc?.stockId) === String(reqObj.stockId),
      );
      const reqBat = clinicStockBatches(reqStock)?.find(
        (bat) => String(bat?.batchId) === String(batchId),
      );
      if (reqBat) {
        const uomList = asArray(reqStock?.uomMappings);
        const batchUom = findMappedUom(uomList, {
          uomMappingId: reqBat?.mapId,
          names: [reqBat?.uomMapName],
        });
        const selectedUom =
          findMappedUom(uomList, {
            uomMappingId: reqObj?.uom?.uomMappingId,
            names: [reqObj?.uom?.name, reqObj?.uom?.value],
          }) ?? reqObj?.uom;
        const reqPrice = roundAmount(
          convertUnitPrice(reqBat?.unitSellingPrice, batchUom, selectedUom),
        );
        reqObj.price = reqPrice;
        reqObj.mrpPrice = reqPrice;
      }
    }
    if (name === "quantity" || name === "batchNumber" || name === "uom") {
      const stockQtyError = reqObj?.stockId
        ? getStockQuantityError(reqObj, {
            forEdit: !!editModVsble && !addModVsble,
          })
        : "";
      const requiredMsg =
        name === "quantity" && (value === "" || Number(value) <= 0)
          ? "This field is required"
          : "";
      reqObj.qtyLimitErr = stockQtyError;
      reqObj.qtyErr = !!requiredMsg && !stockQtyError;
      setAddItemErrs((prev) => ({
        ...prev,
        quantity: stockQtyError || requiredMsg,
      }));
    }
    if (name === "discountType") {
      reqObj.discountValue = value?.value?.toLowerCase() === "code" ? null : 0;
      reqObj.appliedLineDiscount = 0;
    }
    const discountType = (
      name === "discountType" ? value?.value : itemValues?.discountType?.value
    )?.toLowerCase();
    // Price discount: preserve applied line total; re-split per unit when qty changes
    if (discountType === "price") {
      if (name === "discountValue" && typeof value !== "object") {
        const qty = Number(itemValues?.quantity ?? 1) || 1;
        reqObj.appliedLineDiscount = roundAmount(Number(value ?? 0) * qty);
      }
      if (name === "quantity") {
        const oldQty = Number(itemValues?.quantity ?? 1) || 1;
        const newQty = Number(value ?? 1) || 1;
        const lineDisc =
          itemValues?.appliedLineDiscount != null
            ? Number(itemValues.appliedLineDiscount)
            : roundAmount(Number(itemValues?.discountValue ?? 0) * oldQty);
        reqObj.appliedLineDiscount = lineDisc;
        if (newQty > 0) {
          const [perUnit] = allocateExactFlatDiscountPerUnit(
            [
              {
                price: Number(itemValues?.price ?? 0) || 1,
                quantity: newQty,
              },
            ],
            lineDisc,
          );
          reqObj.discountValue = roundAmount(perUnit ?? 0);
        }
      }
    }
    setItemValues(reqObj);
  };

  const handleDelModClose = () => {
    setDelModVisible(false);
    setSelectedItem(null);
  };

  const getBillQty = () => {
    return (
      getTabBasedRecords()?.reduce((acc, curr) => acc + curr?.quantity, 0) ?? 0
    );
  };

  const getDiscountCodes = () => {
    const todayDiscounts = getDiscountCodeAvailableToday(
      discountCodes,
      billDetails?.userId ?? null,
      (activeTab === "Treatment"
        ? getTaxAndSubTotalAndTotal(treatTabList)
        : activeTab === "Pharmacy"
          ? getTaxAndSubTotalAndTotal(pharTabList)
          : getTaxAndSubTotalAndTotal(petShopTabList)
      )?.subTotal ?? 0,
      getBillQty(),
      petBilling?.totalRecords === 1 || !petBilling?.totalRecords,
      (activeTab === "Treatment"
        ? treatTabList
        : activeTab === "Pharmacy"
          ? pharTabList
          : petShopTabList
      )?.some((li) => Number(li?.discount ?? 0) > 0),
      appDet?.pet?.ownershipType ?? null,
    );
    return todayDiscounts?.map((dc) => ({
      name: dc?.discountCode,
      value: dc?.discountCode,
      discountType: dc?.discountType,
      discountValue: dc?.discountValue,
      purchaseType: dc?.purchaseType,
      billingId: dc?.billId,
      limitUsagePerCustomer: dc?.limitUsagePerCustomer,
      limitUsageTotal: dc?.limitUsageTotal,
    }));
  };

  const handleAddDiscount = (isRemoveDiscount = false) => {
    const errs = {};
    if (disValues?.type === "code") {
      errs.discountCode = disValues?.discountCode?.value
        ? ""
        : "This field is required";
    }
    if (disValues?.type !== "code") {
      errs.amt =
        (disValues?.amt ?? "")?.toString()?.length > 0
          ? Number(disValues?.amt) > 0
            ? ""
            : "Value must be positive"
          : "This field is required";
    }
    if (
      !isRemoveDiscount &&
      ((disValues?.type === "code" && errs?.discountCode?.length > 0) ||
        (disValues?.type !== "code" && errs?.amt?.length > 0))
    ) {
      return setDisErrs(errs);
    }
    const reqDiscountType = isRemoveDiscount
      ? "percentage"
      : disValues?.type?.toLowerCase() === "code"
        ? disValues?.discountCode?.discountType?.toLowerCase()
        : disValues?.type?.toLowerCase();
    const reqDiscountValue = isRemoveDiscount
      ? 0
      : disValues?.type === "code"
        ? disValues?.discountCode?.discountValue
        : disValues?.amt;
    const eligibleRecords =
      getTabBasedRecords()?.filter((li) =>
        activeTab === "Treatment"
          ? !(
              (li?.procedureId ?? "")?.toString()?.length > 0 &&
              !li?.mainProcedure &&
              li?.linked !== "N"
            )
          : true,
      ) ?? [];
    // Base on price × quantity; allocate so sum(discount × qty) equals input exactly
    const isFlatDiscount = reqDiscountType !== "percentage";
    const flatPerUnitByIndex = isFlatDiscount
      ? allocateExactFlatDiscountPerUnit(
          eligibleRecords,
          Number(reqDiscountValue ?? 0),
        )
      : null;
    const getPercentageDiscount = (unitPrice) =>
      roundAmount(
        (Number(unitPrice ?? 0) / 100) * Number(reqDiscountValue ?? 0),
      );

    const applyDiscount = eligibleRecords?.map((li, index) => {
      const reqObj = {
        paymentDetailsId: li?.paymentDetailId,
        discount: 0,
        percentage: reqDiscountType === "percentage" ? "pe" : "pr",
        price: 0,
        mrpPrice: 0,
        mrpDiscount: 0,
        tax: 0,
        total: 0,
        quantity: li?.quantity,
      };
      const reqStck = stocks?.find((stc) => stc?.stockId === li?.stockId);
      const reqBat = reqStck?.stockBatch?.find(
        (btch) => btch?.batchId === li?.batchId,
      );
      if (reqBat) {
        const taxPerent = Number(reqBat?.cgst ?? 0) + Number(reqBat?.sgst ?? 0);
        const reqPercent = 100 + Number(taxPerent);
        const unitPrice = roundAmount(
          Number(reqBat?.unitSellingPrice) / (reqPercent / 100),
        );
        const discount = isFlatDiscount
          ? (flatPerUnitByIndex?.[index] ?? 0)
          : getPercentageDiscount(unitPrice);
        const priceAfterDiscount = Number(unitPrice) - Number(discount);
        const taxValue = (taxPerent / 100) * Number(priceAfterDiscount);
        reqObj.price = unitPrice;
        reqObj.discount = discount;
        reqObj.tax = roundAmount(Number(taxValue ?? 0) * Number(li?.quantity));
        reqObj.total = roundAmount(
          (Number(priceAfterDiscount ?? 0) + Number(taxValue ?? 0)) *
            Number(li?.quantity),
        );
        reqObj.mrpPrice = roundAmount(reqBat?.unitSellingPrice);
        reqObj.mrpDiscount = discount;
      }
      if (li?.serviceId) {
        const unitPrice = li?.price;
        const reqServ = services?.find(
          (ser) => ser?.serviceId === li?.serviceId,
        );
        const discount = isFlatDiscount
          ? (flatPerUnitByIndex?.[index] ?? 0)
          : getPercentageDiscount(unitPrice);
        reqObj.price = roundAmount(unitPrice ?? 0);
        const taxPerent =
          reqServ?.taxApplicability?.toLowerCase() === "yes"
            ? Number(reqServ?.tax ?? 0)
            : 0;
        const priceAfterDiscount =
          Number(unitPrice ?? 0) - Number(discount ?? 0);
        const taxValue =
          Number(taxPerent / 100) * Number(priceAfterDiscount ?? 0);
        const priceWithTax =
          Number(priceAfterDiscount ?? 0) + Number(taxValue ?? 0);
        reqObj.discount = discount;
        reqObj.total = roundAmount(
          Number(priceWithTax ?? 0) * Number(li?.quantity),
        );
        reqObj.tax = roundAmount(Number(taxValue ?? 0) * Number(li?.quantity));
        reqObj.mrpPrice = roundAmount(unitPrice ?? 0);
        reqObj.mrpDiscount = discount;
      }
      if (!li?.serviceId && !li?.stockId) {
        const unitPrice = li?.price;
        const discount = isFlatDiscount
          ? (flatPerUnitByIndex?.[index] ?? 0)
          : getPercentageDiscount(unitPrice);
        reqObj.price = roundAmount(unitPrice ?? 0);
        reqObj.tax = 0;
        reqObj.discount = discount;
        reqObj.total = roundAmount(
          (Number(unitPrice ?? 0) - Number(discount ?? 0)) *
            Number(li?.quantity),
        );
        reqObj.mrpPrice = roundAmount(unitPrice ?? 0);
        reqObj.mrpDiscount = discount;
      }
      return reqObj;
    });
    const data = {
      applyDiscount,
      treatmentDiscountType: reqDiscountType === "percentage" ? "pe" : "pr",
      treatmentDiscountValue: roundAmount(reqDiscountValue ?? 0),
      oldTotal: roundWithSignedDiff(
        Number(
          getTaxAndSubTotalAndTotal(
            activeTab === "Treatment"
              ? treatTabList
              : activeTab === "Pet Shop"
                ? petShopTabList
                : pharTabList,
          )?.subTotal,
        ),
      )?.rounded,
      oldTax: Number(
        getTaxAndSubTotalAndTotal(
          activeTab === "Pet Shop"
            ? petShopTabList
            : activeTab === "Pharmacy"
              ? pharTabList
              : treatTabList,
        )?.tax,
      ),
    };
    if (disValues?.discountCode?.value) {
      data.billingId = disValues?.discountCode?.billingId;
      data.purchaseType = "oneTime";
      data.treatmentDiscountId = uniq([
        ...(billDetails?.treatmentDiscountId ?? []),
        disValues?.discountCode?.billingId?.toString(),
      ]);
    }
    dispatch(
      applyTotalDiscountByPayAndDetailId({
        paymentId:
          bill?.paymentId ?? billDetails?.paymentId ?? petDet?.paymentId,
        data,
      }),
    ).then((res) => {
      if (res?.payload) {
        if (disValues?.discountCode?.limitUsageTotal) {
          const reqDis = discountCodes?.find(
            (dc) => dc?.billId === disValues?.discountCode?.billingId,
          );
          const reqObj = {
            discountMethod: reqDis?.discountMethod,
            startDate: !isNaN(Date.parse(reqDis?.startDate))
              ? moment(new Date(reqDis?.startDate)).format("YYYY-MM-DD")
              : null,
            endDate: !isNaN(Date.parse(reqDis?.endDate))
              ? moment(new Date(reqDis?.endDate)).format("YYYY-MM-DD")
              : null,
            discountCode: reqDis?.discountCode,
            discountType: reqDis?.discountType,
            discountValue: reqDis?.discountValue,
            applieTo: reqDis?.applieTo,
            purchaseType: reqDis?.purchaseType,
            categories: reqDis?.categories,
            minRequirementType: reqDis?.minRequirementType,
            minAmount: reqDis?.minAmount,
            minQuantity: reqDis?.minQuantity,
            specificCustomers: reqDis?.specificCustomers,
            limitUsageTotal: reqDis?.limitUsageTotal,
            maxTotalUses: disValues?.discountCode?.limitUsageTotal
              ? roundAmount(Number(reqDis?.maxTotalUses) - 1)
              : reqDis?.maxTotalUses,
            limitUsagePerCustomer: reqDis?.limitUsagePerCustomer,
            maxPerCustomerUses: disValues?.discountCode?.limitUsagePerCustomer
              ? roundAmount(Number(reqDis?.maxPerCustomerUses) - 1)
              : reqDis?.maxPerCustomerUses,
            cannotBeCombined: reqDis?.cannotBeCombined,
            isActive: reqDis?.active,
          };
          dispatch(
            updateDiscountCodeById({
              id: disValues?.discountCode?.billingId,
              data: reqObj,
            }),
          );
        }
        handleUpdatePaymentValues();
        onDiscountModClose();
        getDiscountCodeList(
          billDetails?.clinicId !== clinicDet?.id
            ? `?clinicId=${billDetails?.clinicId}`
            : "",
        );
      }
    });
  };

  const handleUpdatePaymentValues = async () => {
    dispatch(getBillDetailsByPaymentId(reqPaymentId)).then(async (res) => {
      const pay = res?.payload;
      const treatRecords = getTreatmentRecordBasedType(
        pay?.paymentDetails ?? [],
      );
      const pharRecords = getPharmacyRecordBasedType(pay?.paymentDetails ?? []);
      const petShopList = getPetShopRecordBasedType(pay?.paymentDetails ?? []);
      const getTotalValues = getTaxAndSubTotalAndTotal(
        activeTab === "Treatment"
          ? (treatRecords ?? [])
          : activeTab === "Pet Shop"
            ? (petShopList ?? [])
            : (pharRecords ?? []),
      );
      const subTotal =
        roundWithSignedDiff(getTotalValues?.subTotal)?.rounded ?? 0;
      const tax = getTotalValues?.tax ?? 0;
      const discount = getTotalValues?.discount ?? 0;
      const reqAmtPaid = pay?.amtPaid;

      const reqData = {
        paymentId: reqPaymentId,
        data: {
          totalAmt: roundAmount(subTotal ?? 0),
          amtPaid: roundAmount(pay?.amtPaid ?? 0),
          discount: roundAmount(discount ?? 0),
          tax: roundAmount(tax ?? 0),
          tabName:
            activeTab === "Treatment"
              ? "treatment"
              : activeTab === "Pet Shop"
                ? "petShop"
                : "pharmacy",
        },
      };

      dispatch(updateBillingByPaymentId(reqData))?.then((apiRes) => {
        if (apiRes?.payload) {
          dispatch(getBillDetailsByPaymentId(reqPaymentId));
          dispatch(getPaymentErrorLogs(reqPaymentId)).then((res) => {
            setPaymentChangeLogs(
              Array.isArray(res?.payload) ? res.payload : [],
            );
          });
        }
      });
    });
  };

  const getPrevDiscountForAdd = () => {
    let discountType = "percentage";
    let discountValue = 0;
    try {
      const prevDiscountList = getUsedDiscountCodes();
      if (prevDiscountList?.length > 0) {
        const reqObj = getPrevDiscountValues(prevDiscountList);
        if (reqObj?.percentage > 0) {
          discountType = "percentage";
          discountValue = reqObj?.percentage;
        }
        if (reqObj?.price > 0) {
          discountType = "price";
          discountValue = reqObj?.price;
        }
      }
    } catch {
      // keep defaults
    }
    return { discountType, discountValue };
  };

  const buildAddFormFromCatalog = (item) => {
    const { discountType, discountValue } = getPrevDiscountForAdd();
    const form = {
      ...initialValues,
      name: item?.name ?? searchValue ?? "",
      quantity: 1,
      type: item ? (item?.serviceId ? "service" : "product") : "service",
      stockId: item?.stockId ?? null,
      serviceId: item?.serviceId ?? null,
      productId: item?.productId ?? null,
      variantId: item?.variantId ?? null,
      variantNumber: item?.variantNumber ?? null,
      hsnSacCode: item?.hsnSacCode ?? null,
      drugSchedule: item?.drugSchedule ?? null,
      shortName: item?.shortName ?? null,
      patientWorkbook: false,
      autoConsumed: false,
      linkToProcedure: null,
      discountType:
        discountType === "percentage"
          ? dropDiscountTypes?.[1]
          : dropDiscountTypes?.[2],
      discountValue: Number(discountValue ?? 0),
      price: 0,
      mrpPrice: 0,
      batchNumber: null,
      batchId: null,
      uom: null,
      qtyErr: false,
      batchErr: false,
    };

    if (item?.serviceId) {
      const reqService = (services ?? []).find(
        (ser) => ser?.serviceId === item?.serviceId,
      );
      const reqVariant = reqService?.serviceVariants?.find(
        (vnt) => vnt?.variantId === item?.variantId,
      );
      form.price = Number(reqVariant?.servicePrice ?? 0);
      form.mrpPrice = Number(reqVariant?.servicePrice ?? 0);
    }

    if (item?.stockId) {
      if (activeTab === "Treatment") {
        form.patientWorkbook = (treatTabList ?? []).some(
          (li) => li?.stockId === item?.stockId,
        );
      }
      const batchOptions = getBatches(item?.stockId) ?? [];
      const firstBatch = batchOptions?.[0] ?? null;
      const reqBat = firstBatch
        ? clinicStockBatches(
            asArray(stocks).find(
              (stc) => String(stc?.stockId) === String(item?.stockId),
            ),
          )?.find((btc) => String(btc?.batchId) === String(firstBatch?.batchId))
        : null;
      if (reqBat) {
        form.batchId = reqBat?.batchId ?? null;
        form.batchNumber = {
          name: reqBat?.batchNo,
          value: reqBat?.batchId,
          batchId: reqBat?.batchId,
        };
        form.batchNo = reqBat?.batchNo ?? null;
        form.expiryDate = reqBat?.expiryDate ?? null;
        form.packageUom = reqBat?.salesUom ?? null;
        form.locationId = reqBat?.locationId ?? null;
        form.locationName =
          locationForBatch(reqBat)?.locationName ??
          reqBat?.locationName ??
          null;

        const uomList = getUOMListByStockId(item?.stockId) ?? [];
        const matchedUom =
          uomList?.find(
            (ul) =>
              ul?.uomMappingId === reqBat?.mapId ||
              ul?.value === reqBat?.uomMapName,
          ) ?? uomList?.[0];
        const addedUoms = getAddedBatchUomList(item?.stockId, reqBat?.batchId);
        const selectedUom =
          addedUoms?.find(
            (ul) =>
              ul?.uomMappingId === matchedUom?.uomMappingId ||
              ul?.value === matchedUom?.value,
          ) ??
          addedUoms?.[0] ??
          matchedUom;
        form.uom = selectedUom ?? null;

        const batUomMatch = findMappedUom(uomList, {
          uomMappingId: reqBat?.mapId,
          names: [reqBat?.uomMapName],
        });
        const stckUnitPrice = reqBat?.unitSellingPrice ?? 0;
        const reqPrice = convertUnitPrice(
          stckUnitPrice,
          batUomMatch,
          selectedUom,
        );
        form.price = roundAmount(reqPrice);
        form.mrpPrice = roundAmount(reqPrice);
      }
    }

    return form;
  };

  const getAddItemValidationErrors = (form) => {
    const errors = {};
    if (!form?.name || !(form?.stockId || form?.serviceId)) {
      errors.name = "Required";
    }
    if (!form?.quantity || Number(form?.quantity) <= 0) {
      errors.quantity = "This field is required";
    } else if (form?.stockId) {
      const stockQtyError = getStockQuantityError(form);
      if (stockQtyError) errors.quantity = stockQtyError;
    }
    if (form?.stockId) {
      const batchId =
        form?.batchNumber?.batchId ?? form?.batchNumber?.value ?? form?.batchId;
      if (!batchId) errors.batchNumber = "Please select a batch number";
    }
    if (getTaxDiscountAndTotal(form)?.isHigherDiscount) {
      errors.discountValue = "Discount cannot be greater than unit price";
    }
    return errors;
  };

  const buildApiPayloadFromAddForm = (form) => {
    try {
      let discountType = "percentage";
      let discountValue = 0;
      if (typeof form?.discountValue === "object" && form?.discountValue) {
        discountType =
          form?.discountValue?.discountType?.toLowerCase() ?? "percentage";
        discountValue = Number(form?.discountValue?.discountValue ?? 0);
      } else {
        discountType = form?.discountType?.value?.toLowerCase() ?? "percentage";
        discountValue = Number(form?.discountValue ?? 0);
      }

      const qty = Number(form?.quantity) > 0 ? Number(form?.quantity) : 1;
      const totals = getTaxDiscountAndTotal(form) ?? {};
      const unitDiscount =
        qty > 0 ? roundAmount(Number(totals?.discount ?? 0) / qty) : 0;
      const unitTax = qty > 0 ? roundAmount(Number(totals?.tax ?? 0) / qty) : 0;

      const base = {
        name: form?.name ?? "",
        quantity: qty,
        price: roundAmount(form?.price ?? 0),
        mrpPrice: roundAmount(form?.mrpPrice ?? form?.price ?? 0),
        tax: roundAmount(totals?.tax ?? 0),
        total: roundAmount(totals?.total ?? 0),
        discount: unitDiscount,
        mrpDiscount: unitDiscount,
        discountType: discountType === "percentage" ? "pe" : "pr",
        type: form?.type ?? (form?.serviceId ? "service" : "product"),
        billType: billingTabEnum?.[activeTab],
        tabName: billingTabEnum?.[activeTab],
        adminCharge: "N",
        adminChargeAmount: 0,
        amtPaid: roundAmount(billDetails?.amtPaid ?? 0),
        shortName: form?.shortName ?? null,
        linked: form?.linkToProcedure?.apiValue ? "Y" : null,
        autoConsumed: form?.autoConsumed ?? false,
        patientWorkbook: form?.patientWorkbook ?? false,
        hsnSacCode: form?.hsnSacCode ?? null,
        percentage: discountType === "percentage",
        subUnit: "Unit",
      };

      if (form?.stockId) {
        const batchId =
          form?.batchNumber?.batchId ??
          form?.batchNumber?.value ??
          form?.batchId ??
          null;
        const reqStck = getStockById(form?.stockId);
        const reqBat = reqStck?.stockBatch
          ?.filter(
            (btch) => btch?.createdBy === clinicDet?.id && btch?.approved,
          )
          ?.find((btch) => btch?.batchId === batchId);

        let price = roundAmount(form?.price ?? 0);
        let tax = roundAmount(totals?.tax ?? 0);
        let total = roundAmount(totals?.total ?? 0);
        let discount = unitDiscount;

        if (reqBat) {
          const taxPerent =
            Number(reqBat?.cgst ?? 0) + Number(reqBat?.sgst ?? 0);
          const reqPercent = 100 + Number(taxPerent);
          const uomList = getUOMListByStockId(form?.stockId) ?? [];
          const matchedUom = uomList?.find(
            (ul) =>
              ul?.uomMappingId === form?.uom?.uomMappingId ||
              ul?.value === form?.uom?.name ||
              ul?.value === form?.uom?.value,
          );
          const batUomMatch = findMappedUom(uomList, {
            uomMappingId: reqBat?.mapId,
            names: [reqBat?.uomMapName],
          });
          const stckUnitPrice = reqBat?.unitSellingPrice ?? 0;
          const reqPrice = roundAmount(
            convertUnitPrice(stckUnitPrice, batUomMatch, matchedUom),
          );
          const linkedToProcedure =
            activeTab === "Treatment" && form?.linkToProcedure?.apiValue;
          const reqUnitPrice = linkedToProcedure ? 0 : reqPrice;
          const unitPrice = roundAmount(
            Number(reqUnitPrice) / (reqPercent / 100),
          );
          discount = roundAmount(
            discountType === "percentage"
              ? (Number(unitPrice) / 100) * Number(discountValue ?? 0)
              : Number(discountValue ?? 0),
          );
          const priceAfterDiscount = Number(unitPrice) - Number(discount ?? 0);
          const taxValue = (taxPerent / 100) * Number(priceAfterDiscount);
          price = roundAmount(reqUnitPrice);
          tax = roundAmount(Number(taxValue ?? 0) * qty);
          total = roundAmount(
            (Number(priceAfterDiscount ?? 0) + Number(taxValue ?? 0)) * qty,
          );
          return {
            ...base,
            stockId: form?.stockId,
            batchId,
            batchNo: reqBat?.batchNo ?? form?.batchNo ?? null,
            uomId: matchedUom?.uomMappingId ?? null,
            uomName: matchedUom?.value ?? form?.uom?.value ?? null,
            expiryDate: reqBat?.expiryDate ?? form?.expiryDate ?? null,
            drugSchedule: form?.drugSchedule ?? null,
            packageUom: reqBat?.salesUom ?? form?.packageUom ?? null,
            price: roundAmount(unitPrice),
            mrpPrice: roundAmount(reqPrice),
            discount,
            mrpDiscount: discount,
            tax,
            total,
            procedureId: form?.linkToProcedure?.apiValue ?? null,
            locationId: reqBat?.locationId ?? form?.locationId ?? null,
            locationName: form?.locationName ?? null,
          };
        }

        return {
          ...base,
          stockId: form?.stockId,
          batchId,
          batchNo: form?.batchNo ?? null,
          uomId: form?.uom?.uomMappingId ?? null,
          uomName: form?.uom?.value ?? form?.uom?.name ?? null,
          expiryDate: form?.expiryDate ?? null,
          drugSchedule: form?.drugSchedule ?? null,
          packageUom: form?.packageUom ?? null,
          price,
          mrpPrice: roundAmount(form?.mrpPrice ?? price),
          discount,
          mrpDiscount: discount,
          tax,
          total,
          procedureId: form?.linkToProcedure?.apiValue ?? null,
        };
      }

      if (form?.serviceId) {
        const reqServ = (services ?? []).find(
          (ser) => ser?.serviceId === form?.serviceId,
        );
        const reqVar = reqServ?.serviceVariants?.find(
          (vnt) => vnt?.variantId === form?.variantId,
        );
        const unitPrice = Number(form?.price ?? reqVar?.servicePrice ?? 0);
        const taxPercent =
          (reqServ?.taxApplicability ?? "").toLowerCase() === "yes"
            ? Number(reqServ?.tax ?? 0)
            : 0;
        const calculatedDiscount = roundAmount(
          discountType === "percentage"
            ? (Number(unitPrice) / 100) * Number(discountValue ?? 0)
            : Number(discountValue ?? 0),
        );
        const priceAfterDiscount =
          Number(unitPrice) - Number(calculatedDiscount ?? 0);
        const taxValue =
          (Number(priceAfterDiscount ?? 0) / 100) * Number(taxPercent ?? 0);
        return {
          ...base,
          serviceId: form?.serviceId,
          variantId: form?.variantId ?? null,
          variantNumber: form?.variantNumber ?? null,
          procedureId: form?.linkToProcedure?.apiValue ?? null,
          price: roundAmount(unitPrice),
          mrpPrice: roundAmount(unitPrice),
          discount: calculatedDiscount,
          mrpDiscount: calculatedDiscount,
          tax: roundAmount(Number(taxValue ?? 0) * qty),
          total: roundAmount(
            (Number(priceAfterDiscount) + Number(taxValue ?? 0)) * qty,
          ),
          hsnSacCode: form?.hsnSacCode ?? reqServ?.hsnSacCode ?? null,
        };
      }

      // Custom / ad-hoc item
      const unitPrice = Number(form?.price ?? 0);
      const calculatedDiscount = roundAmount(
        discountType === "percentage"
          ? (Number(unitPrice) / 100) * Number(discountValue ?? 0)
          : Number(discountValue ?? 0),
      );
      return {
        ...base,
        price: roundAmount(unitPrice),
        mrpPrice: roundAmount(unitPrice),
        discount: calculatedDiscount,
        mrpDiscount: calculatedDiscount,
        tax: 0,
        total: roundAmount(
          (Number(unitPrice) - Number(calculatedDiscount)) * qty,
        ),
      };
    } catch {
      return null;
    }
  };

  const handleAddItem = async (item) => {
    try {
      if (!item) return;
      const form = buildAddFormFromCatalog(item);
      setItemValues(form);
      setAddItemErrs({});
      setAddModVsble(true);
    } catch {
      dispatch(
        showSnackBar({
          message: "Unable to open add item. Please try again.",
          type: "error",
        }),
      );
    }
  };

  const openAddItemModal = () => {
    setItemValues(initialValues);
    setAddItemErrs({});
    setQueuedAddItems([]);
    setIsAddingItems(false);
    addingItemsRef.current = false;
    setAddModVsble(true);
  };

  const onCloseAddMod = () => {
    setAddModVsble(false);
    setAddItemErrs({});
    setItemValues(initialValues);
    setQueuedAddItems([]);
  };

  const onSelectAddCatalogItem = (value) => {
    try {
      if (!value) {
        setItemValues(initialValues);
        setAddItemErrs({});
        return;
      }
      const form = buildAddFormFromCatalog(value);
      setItemValues({ ...form, nameErr: false });
      setAddItemErrs({});
    } catch {
      dispatch(
        showSnackBar({
          message: "Unable to select item. Please try again.",
          type: "error",
        }),
      );
    }
  };

  const handleQueueAddItem = () => {
    const errors = getAddItemValidationErrors(itemValues);
    if (Object.keys(errors).length > 0) {
      setAddItemErrs(errors);
      setItemValues((prev) => ({
        ...prev,
        nameErr: !!errors.name,
        qtyErr: !!errors.quantity,
        batchErr: !!errors.batchNumber,
      }));
      return;
    }

    setQueuedAddItems((prev) => [...(prev ?? []), { ...itemValues }]);
    setItemValues(initialValues);
    setAddItemErrs({});
    dispatch(
      showSnackBar({
        message: "Item added successfully",
        type: "success",
      }),
    );
  };

  const handleDoneAddItems = async () => {
    if (addingItemsRef.current || isAddingItems) return;

    let itemsToSave = [...(queuedAddItems ?? [])];
    const hasCurrentItem = !!(
      addModVsble &&
      itemValues?.name &&
      (itemValues?.stockId || itemValues?.serviceId || itemValues?.productId)
    );

    if (hasCurrentItem) {
      const errors = getAddItemValidationErrors(itemValues);
      if (Object.keys(errors).length > 0) {
        setAddItemErrs(errors);
        setItemValues((prev) => ({
          ...prev,
          qtyErr: !!errors.quantity,
          batchErr: !!errors.batchNumber,
        }));
        return;
      }
      itemsToSave = [...itemsToSave, { ...itemValues }];
    }

    if (itemsToSave.length === 0) {
      onCloseAddMod();
      setQueuedAddItems([]);
      return;
    }

    if (!reqPaymentId) {
      dispatch(
        showSnackBar({
          message: "Payment not found. Unable to add items.",
          type: "error",
        }),
      );
      return;
    }

    const reqList = itemsToSave
      .map((form) => buildApiPayloadFromAddForm(form))
      .filter(Boolean);

    if (!reqList.length) {
      dispatch(
        showSnackBar({
          message: "Unable to prepare items. Please try again.",
          type: "error",
        }),
      );
      return;
    }

    addingItemsRef.current = true;
    setIsAddingItems(true);
    try {
      const res = await dispatch(
        addBillingItemsToPaymentId({
          paymentId: reqPaymentId,
          data: reqList,
        }),
      );
      if (res?.payload) {
        setQueuedAddItems([]);
        setAddItemErrs({});
        setItemValues(initialValues);
        setAddModVsble(false);
        setSearchVisible(false);
        setSearchValue("");
        handleUpdatePaymentValues();
        refreshStocksAfterStockAction(reqList.some((li) => !!li?.stockId));
      }
    } catch {
      dispatch(
        showSnackBar({
          message: "Unable to add items. Please try again.",
          type: "error",
        }),
      );
    } finally {
      addingItemsRef.current = false;
      setIsAddingItems(false);
    }
  };

  const handleUpdateItem = async (item) => {
    const stockQtyError = getStockQuantityError(itemValues, { forEdit: true });
    if (stockQtyError) return;
    if (getTaxDiscountAndTotal(itemValues)?.isHigherDiscount) return;
    let discountType = "percentage",
      discountValue = 0;
    if (typeof item?.discountValue === "object") {
      discountType = item?.discountValue?.discountType?.toLowerCase();
      discountValue = item?.discountValue?.discountValue;
    }
    if (typeof item?.discountValue !== "object") {
      discountType = item?.discountType?.value?.toLowerCase();
      discountValue = item?.discountValue;
    }
    const reqStck = getStockById(itemValues?.stockId ?? item?.stockId);
    const reqBat = reqStck?.stockBatch
      ?.filter((btch) => btch?.createdBy === clinicDet?.id && btch?.approved)
      ?.find(
        (btch) =>
          btch?.batchId ===
          (item?.batchNumber?.batchId ??
            item?.batchNumber?.value ??
            item?.batchId),
      );
    let discount = roundAmount(
      discountType?.toLowerCase() !== "percentage"
        ? Number(discountValue ?? 0)
        : (Number(itemValues?.price ?? 0) / 100) * Number(discountValue ?? 0),
    );
    const reqObj = {
      paymentDetaisId: selectedItem?.paymentDetailId ?? item?.paymentDetailId,
      tax: 0,
      adminCharge: "N",
      adminChargeAmount: 0,
      quantity: Number(itemValues?.quantity),
      type: selectedItem?.type ?? item?.type,
      percentage: discountType?.toLowerCase() === "percentage",
      stockId: itemValues?.stockId,
      batchId:
        item?.batchNumber?.batchId ?? item?.batchNumber?.value ?? item?.batchId,
      name: itemValues?.name,
      billType: billingTabEnum?.[activeTab],
      serviceId: item?.serviceId,
      patientWorkbook: item?.patientWorkbook ?? false,
      total: roundAmount(item?.total ?? 0),
      mrpPrice: roundAmount(itemValues?.mrpPrice ?? 0),
      tabName: billingTabEnum?.[activeTab],
      autoConsumed: item?.autoConsumed ?? false,
      amtPaid: roundAmount(billDetails?.amtPaid ?? 0),
      diagonisticId: itemValues?.diagonisticId ?? null,
    };
    if (activeTab === "Treatment") {
      reqObj.procedureId = itemValues?.linkToProcedure?.apiValue ?? null;
    }
    if (itemValues?.mainProcedure) {
      reqObj.procedureId = itemValues?.procedureId;
    }
    if (reqBat) {
      const taxPerent = Number(reqBat?.cgst ?? 0) + Number(reqBat?.sgst ?? 0);
      const reqPercent = 100 + Number(taxPerent);
      const uomList = getUOMListByStockId(itemValues?.stockId ?? item?.stockId);
      const matchedUom = uomList?.find(
        (ul) =>
          ul?.uomMappingId === item?.uom?.uomMappingId ||
          ul?.value === item?.uom?.name,
      );
      const batUomMatch = findMappedUom(uomList, {
        uomMappingId: reqBat?.mapId,
        names: [reqBat?.uomMapName],
      });
      const stckUnitPrice = reqBat?.unitSellingPrice ?? 0;
      const reqPrice = roundAmount(
        convertUnitPrice(stckUnitPrice, batUomMatch, matchedUom),
      );
      const reqUnitPrice =
        activeTab === "Treatment" && itemValues?.linkToProcedure?.apiValue
          ? 0
          : reqPrice;
      const unitPrice = roundAmount(Number(reqUnitPrice) / (reqPercent / 100));
      const reqDiscount = roundAmount(
        discountType?.toLowerCase() === "percentage"
          ? (Number(unitPrice) / 100) * Number(discountValue ?? 0)
          : Number(discountValue ?? 0),
      );
      const priceAfterDiscount = Number(unitPrice) - Number(reqDiscount ?? 0);
      const taxValue = (taxPerent / 100) * Number(priceAfterDiscount);
      reqObj.uomId = matchedUom?.uomMappingId ?? null;
      reqObj.uomName = matchedUom?.value ?? null;
      reqObj.price = roundAmount(
        item?.autoConsumed
          ? 0
          : activeTab === "Treatment" && itemValues?.linkToProcedure?.apiValue
            ? 0
            : Number(reqPrice),
      );
      reqObj.discount = roundAmount(
        item?.autoConsumed
          ? 0
          : activeTab === "Treatment" && itemValues?.linkToProcedure?.apiValue
            ? 0
            : Number(reqDiscount ?? 0),
      );
      reqObj.tax = roundAmount(
        item?.autoConsumed
          ? 0
          : activeTab === "Treatment" && itemValues?.linkToProcedure?.apiValue
            ? 0
            : Number(taxValue ?? 0) * Number(itemValues?.quantity),
      );
      reqObj.total = roundAmount(
        item?.autoConsumed
          ? 0
          : activeTab === "Treatment" && itemValues?.linkToProcedure?.apiValue
            ? 0
            : (Number(priceAfterDiscount ?? 0) + Number(taxValue ?? 0)) *
              Number(itemValues?.quantity),
      );
      reqObj.mrpPrice = roundAmount(
        item?.autoConsumed
          ? 0
          : activeTab === "Treatment" && itemValues?.linkToProcedure?.apiValue
            ? 0
            : Number(reqPrice),
      );
      reqObj.mrpDiscount = item?.autoConsumed
        ? 0
        : roundAmount(reqDiscount ?? 0);
      reqObj.hsnSacCode = itemValues?.hsnSacCode ?? null;
      reqObj.drugSchedule = itemValues?.drugSchedule ?? null;
      reqObj.packageUom = reqBat?.salesUom ?? null;
      reqObj.expiryDate = reqBat?.expiryDate ?? null;
      reqObj.batchNo = reqBat?.batchNo ?? null;
      reqObj.shortName = item?.shortName ?? null;
      reqObj.locationId = reqBat?.locationId ?? null;
      reqObj.locationName =
        locations?.find((loc) => loc?.id === reqBat?.locationId)
          ?.locationName ??
        reqBat?.locationName ??
        null;
    }
    if (!item?.serviceId && !item?.stockId) {
      reqObj.price = roundAmount(itemValues?.price ?? 0);
      reqObj.tax = 0;
      reqObj.discount = roundAmount(discount);
      reqObj.total = roundAmount(
        (Number(itemValues?.price ?? 0) - Number(discount ?? 0)) *
          Number(itemValues?.quantity),
      );
      reqObj.mrpPrice = roundAmount(itemValues?.price ?? 0);
      reqObj.mrpDiscount = roundAmount(
        discountType?.toLowerCase() === "percentage"
          ? (Number(itemValues?.price ?? 0) / 100) * Number(discountValue ?? 0)
          : Number(discountValue ?? 0),
      );
    }
    if (item?.serviceId) {
      const reqServ = services?.find(
        (ser) => ser?.serviceId === item?.serviceId,
      );
      const reqVar = reqServ?.serviceVariants?.find(
        (vnt) => vnt?.variantId === item?.variantId,
      );
      const unitPrice =
        Number(itemValues?.price ?? 0) ?? Number(reqVar?.servicePrice ?? 0);
      const taxPerent =
        reqServ?.taxApplicability?.toLowerCase() === "yes"
          ? Number(reqServ?.tax ?? 0)
          : 0;
      const reqDiscount =
        discountType?.toLowerCase() === "percentage"
          ? (Number(unitPrice) / 100) * Number(discountValue ?? 0)
          : Number(discountValue ?? 0);
      const priceAfterDiscount = Number(unitPrice) - Number(reqDiscount ?? 0);
      const taxValue =
        (Number(priceAfterDiscount ?? 0) / 100) * Number(taxPerent ?? 0);
      const priceAfterTax = Number(priceAfterDiscount) + Number(taxValue);
      reqObj.price = unitPrice;
      reqObj.mrpPrice = unitPrice;
      reqObj.mrpDiscount = roundAmount(reqDiscount ?? 0);
      reqObj.discount = roundAmount(reqDiscount ?? 0);
      reqObj.variantId = itemValues?.variantId;
      reqObj.variantNumber = itemValues?.variantNumber;
      reqObj.tax = roundAmount(
        Number(taxValue ?? 0) * Number(itemValues?.quantity ?? 1),
      );
      reqObj.total = roundAmount(
        Number(priceAfterTax ?? 0) * Number(itemValues?.quantity ?? 1),
      );
      reqObj.hsnSacCode = itemValues?.hsnSacCode ?? null;
    }
    const reqData = {
      paymentId: reqPaymentId,
      data: reqObj,
    };
    dispatch(updateBillingItemsByPaymentId(reqData)).then((res) => {
      if (res?.payload) {
        handleUpdatePaymentValues();
        refreshStocksAfterStockAction(!!(itemValues?.stockId || item?.stockId));
        setSelectedItem(null);
        setEditVisible(false);
        setEditModVsble(false);
      }
    });
  };

  const handleClosePrintModal = () => {
    setPrntPrevVsble(false);
  };

  const finalPayment = () => {
    //validation start
    let errs = {};
    if (
      !payValues?.amount ||
      isNaN(Number(payValues?.amount)) ||
      Number(payValues?.amount) <= 0 ||
      Number(payValues?.amount) > totalBalanceDue ||
      (payValues?.paymentMode?.value === "Advance Adjustment" &&
        Number(payValues?.amount) > Number(billDetails?.advanceAmount))
    ) {
      errs = {
        ...errs,
        amount:
          payValues?.paymentMode?.value === "Advance Adjustment" &&
          Number(payValues?.amount) > Number(billDetails?.advanceAmount)
            ? "Insufficient credit balance"
            : !payValues?.amount
              ? "This field is required"
              : Number(payValues?.amount) > totalBalanceDue
                ? "Amount must be less than or equal to balance due"
                : Number(payValues?.amount) <= 0
                  ? "Amount must be positive"
                  : "",
      };
    }
    if (!payValues?.paymentMode?.value) {
      errs = { ...errs, paymentMode: "This field is required" };
    }
    if (Object.values(errs).some((item) => item?.length > 0)) {
      return setPayErr(errs);
    }
    //validation end here
    const data = {
      paymentId: billDetails?.paymentId,
      paymentMode: payValues?.paymentMode?.value,
      paymentAmount: Number(payValues?.amount),
    };
    dispatch(updatePayment(data)).then(async (res) => {
      if (res?.payload) {
        if (bill?.paymentId ?? petDet?.paymentId) {
          dispatch(
            getBillDetailsByPaymentId(bill?.paymentId ?? petDet?.paymentId),
          );
        }
        setPayModalVisible(false);
        setPayValues(initialPayValues);
        setTotalBalanceDue(0);
        setPayErr({});
      }
    });
  };

  const payModClose = (typ) => {
    if (typ === "apiSuccess") {
      dispatch(getBillDetailsByPaymentId(bill?.paymentId ?? petDet?.paymentId));
    }
    setPayModalVisible(false);
  };

  const handleChangeValues = (name, value) => {
    const reqValue = typeof value === "object" ? value?.value : value;
    setPayValues({ ...payValues, [name]: value });
    const errObj = {
      ...payErr,
      [name]: reqValue?.length > 0 ? "" : "This field is required",
    };
    if (name === "paymentMode") {
      if (reqValue !== "Advance Adjustment") {
        errObj.amount = "";
      }
      if (reqValue === "Advance Adjustment") {
        if (Number(billDetails?.advanceAmount ?? 0) <= 0) {
          errObj.amount = "Insufficient credit balance";
        }
      }
    }
    if (name === "amount") {
      if (payValues?.paymentMode?.value === "Advance Adjustment") {
        errObj.amount =
          Number(value) < 0
            ? "Amount must be positive"
            : Number(value) > Number(billDetails?.advanceAmount)
              ? "Insufficient credit balance"
              : "";
      } else {
        errObj.amount = Number(value) < 0 ? "Amount must be positive" : "";
      }
      if (Number(value) > totalBalanceDue) {
        errObj.amount = "Amount must be less than or equal to balance due";
      }
    }
    setPayErr(errObj);
  };

  // const getBatchList = (stockId = null) => {
  //   if (!stockId) return [];
  //   const reqStock = stocks?.find((stc) => stc?.stockId === stockId);
  //   const filteredBatches = reqStock?.stockBatch?.map((btch) => ({
  //     name: btch?.batchNo,
  //     value: btch?.batchNo,
  //     batchId: btch?.batchId,
  //   }));
  //   return filteredBatches;
  // };

  const handleApplyDiscount = () => {
    const reqObj = { ...disValues };
    reqObj.type =
      Number(billDetails?.treatmentDiscountValue ?? 0) > 0
        ? billDetails?.treatmentDiscountType === "pe"
          ? "percentage"
          : "price"
        : "code";
    reqObj.amt = billDetails?.treatmentDiscountValue ?? 0;
    reqObj.discountCode = null;
    setDisValues(reqObj);
    setDisModVsble(true);
  };

  const validateBilledBy = () => {
    const valueNotPresent = !billedByValues?.billedBy?.value;
    const vetNotPresent = !billedByValues?.vet?.value;
    setBilledByValues({
      ...billedByValues,
      error: valueNotPresent,
      vetError: activeTab === "Pharmacy" ? vetNotPresent : false,
    });
    return (
      valueNotPresent || (activeTab === "Pharmacy" ? vetNotPresent : false)
    );
  };

  const tabSourceMap = {
    Treatment: ["clinic", "treatment"],
    Pharmacy: ["pharmacy"],
    "Pet Shop": ["petshop"],
  };

  const getPaymentCollectionsByTab = (collections = null) => {
    const reqList = (
      (collections ? collections : billDetails?.paymentCollections) ?? []
    )?.filter((pc) => {
      const source = (pc?.source ?? "").toLowerCase();
      return tabSourceMap[activeTab]?.includes(source) ?? [];
    });
    return reqList ?? [];
  };

  const getTabBasedCollections = () => {
    const reqSource =
      activeTab === "Treatment"
        ? ["clinic", "treatment"]
        : activeTab === "Pharmacy"
          ? ["pharmacy"]
          : ["petshop"];
    const reqList = (billDetails?.paymentCollections ?? [])
      ?.filter((li) => reqSource.includes((li?.source ?? "")?.toLowerCase()))
      ?.sort((a, b) => {
        const ad = Number(a?.collectionId);
        const bd = Number(b?.collectionId);
        return (Number.isFinite(bd) ? bd : 0) - (Number.isFinite(ad) ? ad : 0);
      });
    return reqList ?? [];
  };

  const onGenerateBill = (notConfirmed = true) => {
    if (notConfirmed && validateBilledBy()) return;
    if (notConfirmed) return setGenBillModVsble(true);
    const totalTax = Number(
      Number(
        getTaxAndSubTotalAndTotal(
          activeTab === "Pet Shop"
            ? petShopTabList
            : activeTab === "Pharmacy"
              ? pharTabList
              : treatTabList,
        )?.tax,
      )?.toFixed(2),
    );
    const billedBy = billedByValues?.billedBy;
    let url = `?checkOut=Y&billedById=${billedBy?.value}&billedByName=${billedBy?.name}&type=${checkoutEnum[billDetails?.type]}&totalTax=${totalTax}&billRemarks=${encodeURIComponent(billRemarks ?? "")}`;
    if (activeTab === "Pharmacy") {
      url += `&doctorId=${billedByValues?.vet?.value}&doctorName=${billedByValues?.vet?.name}`;
    }
    if (billDetails?.appointmentId) {
      url += `&appId=${billDetails?.appointmentId}`;
    }
    if (
      petAndApntData?.appointment?.inpatient &&
      petAndApntData?.inpatientResponse?.patientId
    ) {
      url += `&nonRefundableAmount=${petAndApntData?.inpatientResponse?.depositAmount ?? 0}&inpatientId=${petAndApntData?.inpatientResponse?.patientId}&userId=${billDetails?.userId}`;
    }
    const isInvc = (billDetails?.treatmentInvoiceNumber ?? "")?.startsWith(
      "INV",
    );
    const checkoutAction = isInvc
      ? checkoutDirectBilling({
          paymentId,
          url: `?type=Y&billRemarks=${encodeURIComponent(billRemarks ?? "")}`,
        })
      : checkoutBillingByPaymentId({ paymentId, url });

    dispatch(checkoutAction).then((res) => {
      if (res?.payload) {
        // if (billDetails?.appointmentId) {
        //   dispatch(updateCompleted(billDetails?.appointmentId));
        // }
        setGenBillModVsble(false);
        const prevAmtPaid = Number(amtPaidByTab?.[activeTab] ?? 0);
        const prevTotal = Number(totalByTab?.[activeTab] ?? 0);
        dispatch(getPaymentErrorLogs(reqPaymentId)).then((logRes) => {
          setPaymentChangeLogs(
            Array.isArray(logRes?.payload) ? logRes.payload : [],
          );
        });
        dispatch(getBillDetailsByPaymentId(reqPaymentId)).then((res2) => {
          const pay = res2?.payload;
          const payCollects = getPaymentCollectionsByTab(
            pay?.paymentCollections,
          );
          const amtPaidByTab =
            activeTab === "Treatment"
              ? (pay?.amtPaid ?? 0)
              : activeTab === "Pharmacy"
                ? (pay?.amtPaid ?? 0)
                : (pay?.amtPaid ?? 0);
          if (prevAmtPaid > prevTotal) {
            const data = [
              {
                mode: getTabBasedCollections()?.[0]?.paymentMode ?? "",
                amount: Number(Number(prevTotal) - Number(prevAmtPaid)),
                tabName: payTabEnum?.[activeTab],
                invoiceNo: pay?.treatmentInvoiceNumber ?? "",
              },
            ];
            dispatch(
              payAmountByPaymentId({
                paymentId: reqPaymentId,
                data,
              }),
            ).then((res4) => {
              if (res4?.payload) {
                const form = new FormData();
                form.append("userName", billDetails?.userName);
                if (billDetails?.petName && billDetails?.petId) {
                  form.append("petName", billDetails?.petName);
                  form.append("petId", billDetails?.petId);
                }
                form.append("paymentType", "Collect");
                form.append(
                  "advanceAmount",
                  Number(Math.abs(Number(prevTotal) - Number(prevAmtPaid))),
                );
                form.append(
                  "paymentMode",
                  getTabBasedCollections()?.[0]?.paymentMode ?? "",
                );
                dispatch(
                  updateClinicUserCollectionRefund({
                    // updateClinicUserById({
                    userId: billDetails?.userId,
                    form,
                    successMsg: "Payment updated successfully!",
                  }),
                ).then((res5) => {
                  if (res5?.payload) {
                    if (
                      !(Number(amtPaidByTab) > 0 && payCollects?.length > 0)
                    ) {
                      dispatch(getBillDetailsByPaymentId(reqPaymentId));
                    }
                  }
                });
              }
            });
          }
          if (Number(amtPaidByTab) > 0 && payCollects?.length > 0) {
            const invoiceNoByTab = pay?.treatmentInvoiceNumber ?? "";
            const reqCollctions = payCollects?.map((pc) => ({
              collectionId: pc?.collectionId,
              invoiceNo: invoiceNoByTab,
              status: "APPLIED",
            }));
            dispatch(
              updateMultiCollectionStatusAndInvoiceNo(reqCollctions),
            ).then((res3) => {
              if (res3?.payload) {
                dispatch(getBillDetailsByPaymentId(reqPaymentId));
              }
            });
          }
        });
        if (billDetails?.appointmentId) {
          dispatch(
            getPetAndAppointmentDetailsById({
              petId: billDetails?.petId,
              url: `${billDetails?.appointmentId ? `?appointmentId=${billDetails?.appointmentId}` : ""}`,
            }),
          );
        }
      }
    });
  };

  const onChangeShowValue = (name, value) => {
    const reqObj = { ...showValues, [name]: value };
    if (name === "showSublinePrice" && value) {
      reqObj.showSublineItems = true;
    }
    if (name === "showSublineItems" && !value) {
      reqObj.showSublinePrice = false;
    }
    setShowValues(reqObj);
    dispatch(
      updateBillCheckDetails({
        paymentId: bill?.paymentId ?? petDet?.paymentId,
        showSublineItems: reqObj?.showSublineItems,
        showSublinePrice: reqObj?.showSublinePrice,
      }),
    ).then((res) => {
      if (res?.payload) {
        dispatch(
          getBillDetailsByPaymentId(bill?.paymentId ?? petDet?.paymentId),
        );
      }
    });
  };

  const asArray = (value) => (Array.isArray(value) ? value : []);

  const billLocationCategory = () => {
    if (String(apnt?.appointmentType ?? "").toLowerCase() === "home") {
      return "at-home";
    }
    if (activeTab === "Treatment") return "clinic";
    if (activeTab === "Pharmacy") return "pharmacy";
    if (activeTab === "Pet Shop") return "pet shop";
    return null;
  };

  const clinicStockBatches = (stock) =>
    asArray(stock?.stockBatch).filter(
      (bat) => bat?.createdBy === clinicDet?.id && bat?.approved,
    );

  const locationCategoryText = (value) => {
    if (value == null) return "";
    if (typeof value === "string" || typeof value === "number") {
      return String(value);
    }
    if (typeof value === "object") {
      return String(value?.value ?? value?.name ?? "");
    }
    return "";
  };

  const locationForBatch = (bat) =>
    asArray(locations).find((loc) => {
      const batchLocationId = bat?.locationId;
      if (batchLocationId == null || batchLocationId === "") return false;
      return (
        String(loc?.id ?? "") === String(batchLocationId) ||
        String(loc?.locationId ?? "") === String(batchLocationId)
      );
    });

  const batchMatchesBillLocation = (bat, reqCat) => {
    if (!reqCat) return false;
    const category = locationCategoryText(locationForBatch(bat)?.category)
      .trim()
      .toLowerCase();
    return category === reqCat;
  };

  const searchableBillingItems = useMemo(() => {
    try {
      const reqPrdList = billDetails?.estimate
        ? []
        : asArray(stocks).map((li) => {
            const name = li?.tradeName ?? li?.productName ?? "";
            const clinicBatches = clinicStockBatches(li);
            const allQty = clinicBatches.reduce((acc, obj) => {
              return acc + Number(obj?.quantity ?? 0);
            }, 0);
            return {
              ...li,
              name,
              type: "Product",
              availableQty: allQty > 0 ? allQty : "-",
              stockBatch: [...clinicBatches].sort(
                (a, b) => Number(a?.quantity ?? 0) - Number(b?.quantity ?? 0),
              ),
              _searchText: [
                name,
                li?.tradeName,
                li?.productName,
                li?.skuId,
                li?.barcodeNo,
              ]
                ?.filter(Boolean)
                ?.join(" ")
                ?.toLowerCase(),
            };
          });

      if (activeTab !== "Treatment") return reqPrdList;

      const reqServList = [];
      asArray(services)
        ?.filter((ser) => ser?.active === "Y")
        ?.forEach((ser) => {
          asArray(ser?.serviceVariants)
            ?.filter(
              (vrnt) => vrnt?.createdBy === clinicDet?.id && vrnt?.approved,
            )
            ?.forEach((vrnt) => {
              const name = `${ser?.serviceName ?? ""} (${vrnt?.variantName ?? ""})`;
              reqServList.push({
                name,
                variantId: vrnt?.variantId,
                variantNumber: vrnt?.variantNumber,
                type: "Service",
                category: ser?.category,
                servicePrice: vrnt?.servicePrice ?? 0,
                serviceId: ser?.serviceId,
                hsnSacCode: ser?.hsnSacCode ?? null,
                availableQty: "-",
                _searchText: name.toLowerCase(),
              });
            });
        });

      return [...reqServList, ...reqPrdList];
    } catch {
      return [];
    }
  }, [stocks, services, activeTab, clinicDet?.id, billDetails?.estimate]);

  const getAddItemSelectList = () => {
    try {
      const reqCat = billLocationCategory();

      return asArray(searchableBillingItems)
        ?.filter((sp) => {
          if (sp?.serviceId) return activeTab === "Treatment";
          if (billDetails?.estimate || !sp?.stockId || !reqCat) return false;
          return clinicStockBatches(sp).some((bat) =>
            batchMatchesBillLocation(bat, reqCat),
          );
        })
        ?.map((sp) => {
          const clinicBatches = clinicStockBatches(sp).filter((bat) =>
            batchMatchesBillLocation(bat, reqCat),
          );
          const firstBatch = clinicBatches?.[0] ?? null;
          const displayPrice = sp?.stockId
            ? (firstBatch?.unitSellingPrice ?? 0)
            : (sp?.servicePrice ?? 0);

          let stockStatus = null;
          if (sp?.stockId) {
            const expiryDate = firstBatch?.expiryDate;
            if (expiryDate?.length) {
              const today = moment().startOf("day");
              const expiry = moment(new Date(expiryDate)).startOf("day");
              if (expiry.isBefore(today)) stockStatus = "expired";
              else if (expiry.diff(today, "days") < 30) {
                stockStatus = "nearExpiry";
              }
            }
          }

          return {
            ...sp,
            name: sp?.name,
            value: sp?.stockId
              ? `stock-${sp.stockId}`
              : `service-${sp?.serviceId ?? ""}-${sp?.variantId ?? ""}`,
            displayPrice: Number(displayPrice ?? 0),
            availableQty: sp?.stockId ? (sp?.availableQty ?? "-") : null,
            totalQty: sp?.stockId
              ? Number(
                  clinicBatches?.reduce(
                    (acc, bat) => acc + Number(bat?.quantity ?? 0),
                    0,
                  ) ?? 0,
                )
              : null,
            stockStatus,
            itemTypeTag: sp?.stockId ? "Product" : "Service",
          };
        });
    } catch {
      return [];
    }
  };

  const filteredSearchList = useMemo(() => {
    try {
      if (!searchVisible || !searchValue?.length) return [];
      const searchLower = String(searchValue).trim().toLowerCase();
      if (!searchLower) return [];

      const reqCat = billLocationCategory();

      const matchesStockLocationRules = (sp) => {
        if (billDetails?.estimate || !sp?.stockId || !reqCat) return false;
        return clinicStockBatches(sp).some((bat) =>
          batchMatchesBillLocation(bat, reqCat),
        );
      };

      const searchTokens = searchLower?.split(/\s+/)?.filter(Boolean);
      const matchesKeywordSearch = (haystack) => {
        if (!haystack) return false;
        if (haystack?.includes(searchLower)) return true;
        return (
          searchTokens?.length > 0 &&
          searchTokens?.every((token) => haystack?.includes(token))
        );
      };

      const maxResults = 100;
      const results = [];
      const itemList = asArray(searchableBillingItems);
      for (
        let i = 0;
        i < itemList.length && results.length < maxResults;
        i += 1
      ) {
        const sp = itemList[i];
        if (sp?.serviceId) {
          if (activeTab !== "Treatment") continue;
        } else if (!matchesStockLocationRules(sp)) continue;
        if (!matchesKeywordSearch(sp?._searchText ?? "")) continue;
        results.push(sp);
      }
      return results;
    } catch {
      return [];
    }
  }, [
    searchVisible,
    searchValue,
    searchableBillingItems,
    activeTab,
    apnt?.appointmentType,
    locations,
    clinicDet?.id,
    billDetails?.estimate,
  ]);

  const getCorrectedBillDetails = () => {
    if (
      petAndApntData?.appointment?.inpatient &&
      petAndApntData?.inpatientResponse?.patientId
    ) {
      return {
        ...billDetails,
        inpatient:
          petAndApntData?.appointment?.inpatient &&
          petAndApntData?.inpatientResponse?.patientId,
        inpatientDepositAmount:
          petAndApntData?.inpatientResponse?.depositAmount ?? 0,
      };
    }
    return billDetails;
  };

  const onCloseEditMod = () => {
    setEditModVsble(false);
    setItemValues(null);
    setSelectedItem(null);
  };

  const findMappedUom = (uomList, { uomMappingId, names = [] } = {}) => {
    const list = asArray(uomList);
    if (uomMappingId != null && uomMappingId !== "") {
      const byId = list.find(
        (ul) => String(ul?.uomMappingId ?? "") === String(uomMappingId),
      );
      if (byId) return byId;
    }
    for (const name of names) {
      const unit = String(name ?? "")
        .trim()
        .toLowerCase();
      if (!unit) continue;
      const matches = list.filter(
        (ul) =>
          String(ul?.unit ?? ul?.value ?? ul?.name ?? "")
            .trim()
            .toLowerCase() === unit,
      );
      if (!matches.length) continue;
      const clinicMatch = matches.find(
        (ul) =>
          clinicDet?.id != null &&
          String(ul?.createdBy ?? "") === String(clinicDet.id),
      );
      return clinicMatch ?? matches[0];
    }
    return null;
  };

  const uomUnitName = (uom) =>
    String(uom?.unit ?? uom?.value ?? uom?.name ?? "")
      .trim()
      .toLowerCase();

  const positiveConversion = (uom) => {
    const value = Number(uom?.conversion);
    return Number.isFinite(value) && value > 0 ? value : 1;
  };

  // Mapping conversion is how many of that unit equal 1 purchase unit.
  // Strip 10 and box 1 means 1 box = 10 strips, so a strip price is
  // multiplied by 10 for a box and a box price is divided by 10 for a strip.
  const batchUnitsPerSelected = (batchUom, selectedUom) => {
    const sameId =
      batchUom?.uomMappingId != null &&
      selectedUom?.uomMappingId != null &&
      String(batchUom.uomMappingId) === String(selectedUom.uomMappingId);
    const batchName = uomUnitName(batchUom);
    const selectedName = uomUnitName(selectedUom);
    if (sameId || (batchName && batchName === selectedName)) return 1;

    return positiveConversion(batchUom) / positiveConversion(selectedUom);
  };

  const convertBatchQty = (quantity, batchUom, selectedUom) => {
    const perSelected = batchUnitsPerSelected(batchUom, selectedUom) || 1;
    return Number(quantity ?? 0) / perSelected;
  };

  const convertUnitPrice = (unitPrice, batchUom, selectedUom) =>
    Number(unitPrice ?? 0) *
    (batchUnitsPerSelected(batchUom, selectedUom) || 1);

  const getBatch = (stkId = null, batchId = null) => {
    try {
      if (!stkId || !batchId) return null;
      const reqStock = asArray(stocks).find(
        (stc) => String(stc?.stockId) === String(stkId),
      );
      return (
        clinicStockBatches(reqStock)?.find(
          (bat) => String(bat?.batchId) === String(batchId),
        ) ?? null
      );
    } catch {
      return null;
    }
  };

  const getBatches = (stkId = null) => {
    try {
      if (billDetails?.estimate || stkId == null || stkId === "") return [];
      const reqStock = asArray(stocks).find(
        (stc) => String(stc?.stockId) === String(stkId),
      );
      const reqCat = billLocationCategory();
      const clinicBatches = clinicStockBatches(reqStock)?.filter(
        (btch) =>
          Number(btch?.quantity ?? 0) >= 1 &&
          batchMatchesBillLocation(btch, reqCat),
      );
      const uomList = asArray(reqStock?.uomMappings);
      const targetUom =
        findMappedUom(uomList, {
          uomMappingId: itemValues?.uom?.uomMappingId,
          names: [itemValues?.uom?.name, itemValues?.uom?.value],
        }) ?? findMappedUom(uomList, { names: [reqStock?.salesUom] });
      const displayUom =
        itemValues?.uom?.name ??
        itemValues?.uom?.value ??
        reqStock?.salesUom ??
        "";
      return [...(clinicBatches ?? [])]
        ?.sort((a, b) => Number(a?.quantity ?? 0) - Number(b?.quantity ?? 0))
        ?.map((bat) => {
          const reqLocation = locationForBatch(bat);
          const batchUom = findMappedUom(uomList, {
            uomMappingId: bat?.qtyMapId,
            names: [bat?.qtyMapName],
          });
          const batUomQty = convertBatchQty(bat?.quantity, batchUom, targetUom);

          return {
            name: bat?.batchNo,
            value: bat?.batchId,
            subunits: bat?.subunits,
            quantity: bat?.quantity,
            locationId: bat?.locationId,
            locationName: reqLocation?.locationName ?? "",
            batchId: bat?.batchId,
            uomQuantity: batUomQty,
            uom: displayUom,
            binName: bat?.binName ?? "",
          };
        })
        ?.filter((bat) => Number(bat?.uomQuantity ?? 0) > 0);
    } catch {
      return [];
    }
  };

  const getBatchAvailableInUom = (form) => {
    const batchId =
      form?.batchNumber?.batchId ?? form?.batchNumber?.value ?? form?.batchId;
    if (!form?.stockId || !batchId) return null;
    const reqStock = asArray(stocks).find(
      (stc) => String(stc?.stockId) === String(form.stockId),
    );
    if (!reqStock) return null;
    const raw = clinicStockBatches(reqStock)?.find(
      (bat) => String(bat?.batchId) === String(batchId),
    );
    if (!raw) return 0;
    const uomList = asArray(reqStock?.uomMappings);
    const batchUom = findMappedUom(uomList, {
      uomMappingId: raw?.qtyMapId,
      names: [raw?.qtyMapName],
    });
    const targetUom =
      findMappedUom(uomList, {
        uomMappingId: form?.uom?.uomMappingId,
        names: [form?.uom?.name, form?.uom?.value],
      }) ?? findMappedUom(uomList, { names: [reqStock?.salesUom] });
    const available = convertBatchQty(raw?.quantity, batchUom, targetUom);
    return Number.isFinite(available) ? available : 0;
  };

  const getStockQuantityError = (form, { forEdit = false } = {}) => {
    if (!form?.stockId || billDetails?.estimate) return "";
    const qty = Number(form?.quantity);
    if (!Number.isFinite(qty) || qty <= 0) return "";
    const batchId =
      form?.batchNumber?.batchId ?? form?.batchNumber?.value ?? form?.batchId;
    if (!batchId) return "";
    const batchAvailable = getBatchAvailableInUom(form);
    if (batchAvailable == null) return "";
    let available = batchAvailable;
    if (forEdit) {
      const sameBatch = String(selectedItem?.batchId ?? "") === String(batchId);
      const sameUom =
        selectedItem?.uomId == null ||
        form?.uom?.uomMappingId == null ||
        String(selectedItem?.uomId) === String(form?.uom?.uomMappingId);
      if (sameBatch && sameUom) {
        available += Number(selectedItem?.quantity ?? 0);
      }
    } else {
      const queuedQty = (queuedAddItems ?? []).reduce((sum, li) => {
        const liBatch =
          li?.batchNumber?.batchId ?? li?.batchNumber?.value ?? li?.batchId;
        const sameStock = String(li?.stockId) === String(form.stockId);
        const sameBatch = String(liBatch ?? "") === String(batchId);
        const sameUom =
          String(li?.uom?.uomMappingId ?? "") ===
          String(form?.uom?.uomMappingId ?? "");
        if (!sameStock || !sameBatch || !sameUom) return sum;
        return sum + Number(li?.quantity ?? 0);
      }, 0);
      available -= queuedQty;
    }
    if (qty > available + 0.0001) {
      const shown = Math.max(0, Math.round(available * 100) / 100);
      return `Quantity cannot exceed available quantity (${shown})`;
    }
    return "";
  };

  const getTaxDiscountAndTotal = (itm) => {
    let tax = 0,
      discount = 0,
      total = 0,
      price = 0,
      discountType = "percentage",
      discountValue = 0,
      quantity = Number(itm?.quantity ?? 1),
      isHigherDiscount = false;

    // Extract discount type and value
    if (typeof itm?.discountValue === "object") {
      discountType = itm?.discountValue?.discountType?.toLowerCase();
      discountValue = Number(itm?.discountValue?.discountValue ?? 0);
    } else {
      discountType = itm?.discountType?.value?.toLowerCase() || "percentage";
      discountValue = Number(itm?.discountValue ?? 0);
    }
    // Handle stock items (products)
    if (itm?.stockId) {
      const reqStockBatch = stocks
        ?.find((stc) => stc?.stockId === itm?.stockId)
        ?.stockBatch?.filter(
          (btch) => btch?.createdBy === clinicDet?.id && btch?.approved,
        );
      const reqBat =
        (itm?.batchNumber?.batchId ?? itm?.batchId)
          ? reqStockBatch?.find(
              (bat) =>
                bat?.batchId === (itm?.batchNumber?.batchId ?? itm?.batchId),
            )
          : reqStockBatch?.[0];
      if (reqBat) {
        const uomList = getUOMListByStockId(itm?.stockId);
        const matchedUom = uomList?.find(
          (ul) =>
            ul?.uomMappingId === itemValues?.uom?.uomMappingId ||
            ul?.value === itemValues?.uom?.name,
        );
        const batUomMatch = findMappedUom(uomList, {
          uomMappingId: reqBat?.mapId,
          names: [reqBat?.uomMapName],
        });
        const stckUnitPrice = reqBat?.unitSellingPrice ?? 0;
        const itmPrice = convertUnitPrice(
          stckUnitPrice,
          batUomMatch,
          matchedUom,
        );
        const unitPrice = itm?.autoConsumed
          ? 0
          : activeTab === "Treatment" && itm?.linkToProcedure?.apiValue
            ? 0
            : Number(itmPrice ?? 0);
        const taxPercent =
          Number(reqBat?.cgst ?? 0) + Number(reqBat?.sgst ?? 0);
        const reqPack = reqBat?.packageUom?.match(/^(\d+)(.+)/);
        const reqPrice = (Number(unitPrice) ?? 0) / Number(reqPack?.[1] ?? 1);
        const reqUnitPrice = itm?.autoConsumed
          ? 0
          : activeTab === "Treatment"
            ? itm?.linkToProcedure?.apiValue
              ? 0
              : itmPrice
            : itmPrice;
        const reqPercent = 100 + Number(taxPercent);
        const unitPriceExcludingTax = Number(reqUnitPrice) / (reqPercent / 100);
        const calculatedDiscount =
          discountType === "percentage"
            ? (Number(unitPriceExcludingTax) / 100) * Number(discountValue ?? 0)
            : Number(discountValue ?? 0);
        const priceAfterDiscount =
          Number(unitPriceExcludingTax) - Number(calculatedDiscount);
        const taxValue = (taxPercent / 100) * Number(priceAfterDiscount);
        price = unitPriceExcludingTax;
        discount = Number(calculatedDiscount) * quantity;
        tax = Number(taxValue ?? 0) * quantity;
        total =
          Number(Number(priceAfterDiscount ?? 0) + Number(taxValue ?? 0)) *
          quantity;
        isHigherDiscount =
          discountType === "percentage"
            ? Number(calculatedDiscount) > Number(unitPriceExcludingTax)
            : Number(discountValue ?? 0) > Number(unitPriceExcludingTax);
      }
    } else if (itm?.serviceId) {
      // Service items: with tax calculation
      const reqServ = services?.find(
        (ser) => ser?.serviceId === itm?.serviceId,
      );
      const reqVar = reqServ?.serviceVariants?.find(
        (vnt) => vnt?.variantId === itm?.variantId,
      );
      const unitPrice =
        Number(itm?.price ?? 0) ?? Number(reqVar?.servicePrice ?? 0);
      const taxPercent =
        reqServ?.taxApplicability?.toLowerCase() === "yes"
          ? Number(reqServ?.tax ?? 0)
          : 0;
      const calculatedDiscount =
        discountType === "percentage"
          ? (Number(unitPrice) / 100) * Number(discountValue ?? 0)
          : Number(discountValue ?? 0);
      const priceAfterDiscount =
        Number(unitPrice) - Number(calculatedDiscount ?? 0);
      const taxValue =
        (Number(priceAfterDiscount ?? 0) / 100) * Number(taxPercent ?? 0);
      const priceAfterTax = Number(priceAfterDiscount) + Number(taxValue);
      price = unitPrice;
      discount = Number(calculatedDiscount) * quantity;
      tax = Number(taxValue ?? 0) * quantity;
      total = Number(priceAfterTax ?? 0) * quantity;
      isHigherDiscount =
        discountType === "percentage"
          ? Number(calculatedDiscount) > Number(unitPrice)
          : Number(discountValue ?? 0) > Number(unitPrice);
    } else {
      // Custom items (no stockId and no serviceId)
      price = Number(itm?.price ?? 0);
      const calculatedDiscount =
        discountType === "percentage"
          ? (Number(price) / 100) * Number(discountValue ?? 0)
          : Number(discountValue ?? 0);

      discount = Number(calculatedDiscount) * quantity;
      tax = 0;
      total = (Number(price) - Number(calculatedDiscount)) * quantity;
      isHigherDiscount =
        discountType === "percentage"
          ? Number(calculatedDiscount) > Number(price)
          : Number(discountValue ?? 0) > Number(price);
    }

    return { tax, discount, total, isHigherDiscount };
  };

  const isProcedurePresent = () => {
    const isProcedureAvail = treatTabList?.some(
      (li) =>
        (li?.procedureId ?? "")?.toString()?.length > 0 &&
        li?.patientWorkbook &&
        !li?.procedureDetailId,
    );
    return activeTab === "Treatment" && isProcedureAvail && itemValues?.stockId;
  };

  const getProcedureList = () => {
    const reqList = treatTabList
      ?.filter(
        (li) =>
          (li?.procedureId ?? "")?.toString()?.length > 0 &&
          li?.patientWorkbook &&
          !li?.procedureDetailId,
      )
      ?.map((li) => ({
        name: li?.name,
        value: li?.name,
        apiValue: li?.procedureId,
      }));
    return [
      {
        name: "Not linked to a procedure",
        value: "Not linked to a procedure",
        apiValue: null,
      },
      ...(reqList ?? []),
    ];
  };

  const handlePay = () => {
    setPayModalVisible(true);
  };

  const getBilledByList = () => {
    const reqList = (clinicVets ?? [])
      ?.filter((li) =>
        [...rolesForBilling, "ROLE_DOCTOR"].includes(li?.userRole),
      )
      ?.map((li) => ({ name: li?.name, value: li?.doctorId }));
    return reqList;
  };

  const getVetList = () => {
    const reqList = (clinicVets ?? [])
      ?.filter((li) => li?.userRole === "ROLE_DOCTOR")
      ?.map((li) => ({ name: li?.name, value: li?.doctorId }));
    return reqList;
  };

  const onChangeBilledBy = (name, value, err) => {
    setBilledByValues({
      ...billedByValues,
      [name]: value,
      [err]: value?.value ? false : true,
    });
  };

  const onNavBack = () => {
    dispatch(
      checkoutBillingByPaymentId({
        paymentId,
        url: `?type=Clinic&&billRemarks=${encodeURIComponent(billRemarks ?? "")}`,
        showFeedback: false,
      }),
    );
    if (
      typeof setSelectedBill === "function" &&
      typeof setEditBill === "function"
    ) {
      dispatch(setBillDetails(null));
      setSelectedBill(null);
      setEditBill(false);
    }
  };

  const onDiscardBill = () => {
    setDelModVisible(true);
  };

  const genBillVsble = () => {
    if (billDetails?.checkOut === "Y") return false;
    if (billDetails?.appointmentStatus === "recovery") return false;
    const isApptStatusReady =
      billDetails?.appointmentType === "Virtual"
        ? billDetails?.appointmentStatus === "inprogress"
        : billDetails?.appointmentStatus === "finalize";
    if (
      billDetails?.type === "Clinic" &&
      ((!billDetails?.appointmentId && billDetails?.estimate) ||
        (billDetails?.appointmentId && !isApptStatusReady))
    ) {
      return false;
    }
    switch (billDetails?.type) {
      case "Clinic":
        return (
          getTreatmentRecordBasedType(billDetails?.paymentDetails)?.length >
            0 ||
          (isApptStatusReady && activeTab === "Treatment")
        );
      case "Pharmacy":
        return (
          pharTabList?.length > 0 ||
          (activeTab === "Pharmacy" && Number(billDetails?.amtPaid ?? 0) > 0)
        );
      default:
        return (
          petShopTabList?.length > 0 ||
          (activeTab === "Pet Shop" && Number(billDetails?.amtPaid ?? 0) > 0)
        );
    }
  };

  const treatGenBillVsble = () => {
    const isEstimate = billDetails?.type === "Clinic" && billDetails?.estimate;
    if (isEstimate) return false;
    if (billDetails?.checkOut === "Y") return false;
    const isPos =
      billDetails?.type === "Clinic" &&
      !billDetails?.estimate &&
      !billDetails?.appointmentId;
    if (isPos) {
      return treatTabList?.length > 0;
    }
    const hasClinicAppointment =
      billDetails?.type === "Clinic" ? billDetails?.appointmentId : true;
    if (!hasClinicAppointment) return false;

    return (
      (billDetails?.type === "Treatment" && treatTabList?.length > 0) ||
      (billDetails?.appointmentStatus === "finalize" &&
        activeTab === "Treatment")
    );
  };

  const onCloseGenBillMod = () => setGenBillModVsble(false);

  const deleteEditVisbile = () => {
    const reqValue = billDetails?.checkOut !== "Y";
    return reqValue;
  };

  const onCollectClose = (typ) => {
    if (typ === "apiSuccess") {
      dispatch(
        getBillDetailsByPaymentId(
          bill?.paymentId ?? billDetails?.paymentId ?? petDet?.paymentId,
        ),
      );
    }
    setDepositVsble(false);
  };

  const getStockById = (stkId) => {
    return stocks?.find((stc) => stc?.stockId === stkId) ?? null;
  };

  const getUOMListByStockId = (stkId = null) => {
    if (!stkId) return [];
    const stockMat = getStockById(stkId);
    if (!stockMat) return [];
    const reqList = stockMat?.uomMappings
      ?.filter(
        (ml) =>
          ml?.allowSale === "Y" && ml?.show && ml?.createdBy === clinicDet?.id,
      )
      ?.map((ml) => ({
        name: ml?.unit,
        value: ml?.unit,
        conversion: ml?.conversion,
        uomMappingId: ml?.uomMappingId ?? null,
      }));
    return reqList;
  };

  const getAddedBatchUomList = (stockId = null, batchId = null) => {
    const saleUoms = getUOMListByStockId(stockId) ?? [];
    if (!stockId || !batchId) return saleUoms;

    const existingLines = [
      ...(getTabBasedRecords() ?? []),
      ...(queuedAddItems ?? []),
    ]?.filter((li) => {
      const liBatch =
        li?.batchNumber?.batchId ?? li?.batchNumber?.value ?? li?.batchId;
      return (
        String(li?.stockId ?? "") === String(stockId) &&
        String(liBatch ?? "") === String(batchId)
      );
    });
    if (!existingLines.length) return saleUoms;

    const addedIds = existingLines
      ?.map((li) => li?.uomId ?? li?.uom?.uomMappingId)
      ?.filter((id) => id != null && id !== "")
      ?.map((id) => String(id));
    const addedNames = existingLines
      ?.map((li) => li?.uomName ?? li?.uom?.value ?? li?.uom?.name)
      ?.filter((name) => typeof name === "string" && name.trim())
      ?.map((name) => name.trim().toLowerCase());
    if (!addedIds.length && !addedNames.length) return saleUoms;

    const addedUoms = saleUoms.filter((ul) => {
      const id = ul?.uomMappingId != null ? String(ul.uomMappingId) : "";
      const name = String(ul?.value ?? ul?.name ?? "")
        ?.trim()
        ?.toLowerCase();
      return (
        (id && addedIds.includes(id)) || (name && addedNames.includes(name))
      );
    });
    return addedUoms.length > 0 ? addedUoms : saleUoms;
  };

  const checkoutMap = {
    Treatment: billDetails?.checkOut,
    Pharmacy: billDetails?.checkOut,
    "Pet Shop": billDetails?.checkOut,
  };

  const checkStatus = checkoutMap[activeTab];

  const handleSwitchType = () => {
    setSwitchValues({ visible: true, type: billDetails?.type });
  };

  const onChange = (name, value) => {
    setSwitchValues({ ...switchValues, [name]: value });
  };

  const onUpdateType = () => {
    if (!billDetails?.paymentId) return;
    dispatch(
      updatePaymentTypeById({
        paymentId: billDetails?.paymentId,
        url: `?type=${switchValues?.type}`,
      }),
    ).then((res) => {
      if (res?.payload) {
        setSwitchValues({ visible: false });
        dispatch(getBillDetailsByPaymentId(billDetails?.paymentId));
      }
    });
  };

  return (
    <div className="back-white w100Per">
      <div className="scroll-80vh billing-scroll-wrap" ref={billingScrollRef}>
        <div className="light-blue-back3 br5 ph20 pv10">
          <div className="flex-row-ali-cen">
            <Typography className="font-medium fs14 gray4">
              {billDetails?.appointmentId ? "Appointment " : ""}Date/Time
            </Typography>
            <Typography className="black fs14 font-bold ml5">
              {moment(
                new Date(
                  billDetails?.appointmentId
                    ? billDetails?.appointmentdateTime
                    : billDetails?.createdDate,
                ),
              ).format("DD MMM YYYY, HH:mm")}
            </Typography>
            {billDetails?.backDated?.length > 0 ? (
              <>
                <Typography className="font-medium fs14 gray4 ml20">
                  Back Dated
                </Typography>
                <Typography className="black fs14 font-bold ml5">
                  {moment(new Date(billDetails?.backDated)).format(
                    "DD MMM YYYY",
                  )}
                </Typography>
              </>
            ) : null}
            <Typography className="font-medium fs14 gray4 ml20">
              Type
            </Typography>
            <Typography className="black fs14 font-bold ml5">
              {billDetails?.appointmentId
                ? "Appointment"
                : billDetails?.estimate
                  ? "Estimate"
                  : `POS - ${billDetails?.type}`}
            </Typography>
            {!billDetails?.appointmentId && !billDetails?.estimate ? (
              <div
                className="flex-row-ali-cen ml10 cursor"
                onClick={handleSwitchType}
              >
                <WifiProtectedSetupIcon sx={w15h15BlueIcon} />
                <Typography className="blue-color fs14 font-bold">
                  Switch
                </Typography>
              </div>
            ) : null}
            {billDetails?.appointmentId ? (
              <>
                {billDetails?.caseId ? (
                  <>
                    <Typography className="font-medium fs14 gray4 ml20">
                      Case ID
                    </Typography>
                    <Typography className="black fs14 font-bold ml5">
                      {billDetails?.caseId ?? ""}
                    </Typography>
                  </>
                ) : null}
                {billDetails?.doctorName?.length > 0 ? (
                  <>
                    <Typography className="font-medium fs14 gray4 ml20">
                      Vet Name
                    </Typography>
                    <Typography className="black fs14 font-bold ml5">
                      {billDetails?.doctorName}
                    </Typography>
                  </>
                ) : null}
                {/* <Typography className="font-medium fs14 gray4 ml20">
                  Appointment Date/Time
                </Typography>
                <Typography className="black fs14 font-bold ml5">
                  {moment(billDetails?.appointmentdateTime).format(
                    "DD MMM YYYY, HH:mm",
                  )}
                </Typography> */}
              </>
            ) : null}
          </div>
        </div>
        {billDetails?.type === "Clinic" &&
        !billDetails?.appointmentId ? null : (
          <div className="light-blue-back3 br5 ph20 pv10 mt5">
            <div className="flex-row-ali-cen">
              <Typography className="font-medium fs14 gray4">
                {checkStatus !== "Y" ? "Unapplied Credit" : "Amount Paid"}
              </Typography>
              <Typography
                className={`${checkStatus !== "Y" ? "yellow-color" : "green-color"} fs14 font-bold ml5`}
              >
                Rs{" "}
                {Number(Number(billDetails?.amtPaid ?? 0)) > 0
                  ? Number(Number(billDetails?.amtPaid ?? 0))?.toFixed(2)
                  : Number(Number(billDetails?.amtPaid ?? 0))}
              </Typography>
              {petAndApntData?.appointment?.inpatient &&
              petAndApntData?.inpatientResponse?.patientId &&
              Number(petAndApntData?.inpatientResponse?.depositAmount ?? 0) >
                0 ? (
                <>
                  <Typography className="font-medium fs14 gray4 ml20">
                    Non-refundable deposit
                  </Typography>
                  <Typography className={`card-gray2 fs14 font-bold ml5`}>
                    {`Rs ${Number(Number(petAndApntData?.inpatientResponse?.depositAmount ?? 0))?.toFixed(2)}`}
                  </Typography>
                </>
              ) : null}
              {checkStatus === "Y" ? (
                <>
                  <Typography className="font-medium fs14 gray4 ml20">
                    Balance Due
                  </Typography>
                  <Typography className="yellow-color fs14 font-bold ml5">
                    Rs{" "}
                    {Number(
                      Number(
                        activeTab === "Treatment"
                          ? roundWithSignedDiff(
                              getTaxAndSubTotalAndTotal(treatTabList)?.subTotal,
                            )?.rounded
                          : activeTab === "Pharmacy"
                            ? roundWithSignedDiff(
                                getTaxAndSubTotalAndTotal(pharTabList)
                                  ?.subTotal,
                              )?.rounded
                            : roundWithSignedDiff(
                                getTaxAndSubTotalAndTotal(petShopTabList)
                                  ?.subTotal,
                              )?.rounded,
                      ) - Number(Number(billDetails?.amtPaid ?? 0)),
                    )?.toFixed(2)}
                  </Typography>
                </>
              ) : null}
              <div className="flex1-end">
                {isBillSeparated ? (
                  <>
                    {billDetails?.type === "Treatment" ||
                    billDetails?.type === "Clinic" ? (
                      <>
                        <Typography className="font-medium fs14 gray4">
                          Treatment
                        </Typography>
                        <Typography className="black fs14 font-bold ml5">
                          Rs{" "}
                          {Number(
                            Number(
                              roundWithSignedDiff(
                                getTaxAndSubTotalAndTotal(treatTabList)
                                  ?.subTotal,
                              )?.rounded,
                            ),
                          )?.toFixed(2)}
                        </Typography>
                      </>
                    ) : null}
                    {!billDetails?.appointmentId &&
                    (billDetails?.type === "Pharmacy" ||
                      billDetails?.type === "Clinic") ? (
                      <>
                        <Typography className="font-medium fs14 gray4 ml20">
                          Pharmacy
                        </Typography>
                        <Typography className="black fs14 font-bold ml5">
                          Rs{" "}
                          {Number(
                            Number(
                              roundWithSignedDiff(
                                getTaxAndSubTotalAndTotal(pharTabList)
                                  ?.subTotal,
                              )?.rounded,
                            ),
                          )?.toFixed(2)}
                        </Typography>
                      </>
                    ) : null}
                    {!billDetails?.appointmentId &&
                    (billDetails?.type === "Pet Shop" ||
                      billDetails?.type === "Clinic") ? (
                      <>
                        <Typography className="font-medium fs14 gray4 ml20">
                          Pet Shop
                        </Typography>
                        <Typography className="black fs14 font-bold ml5">
                          Rs{" "}
                          {Number(
                            Number(
                              roundWithSignedDiff(
                                getTaxAndSubTotalAndTotal(petShopTabList)
                                  ?.subTotal,
                              )?.rounded,
                            ),
                          )?.toFixed(2)}
                        </Typography>
                      </>
                    ) : null}
                  </>
                ) : (
                  <>
                    <Typography className="font-medium fs14 gray4 ml20">
                      Total
                    </Typography>
                    <Typography className="black fs14 font-bold ml5">
                      Rs{" "}
                      {Number(
                        Number(
                          roundWithSignedDiff(
                            getTaxAndSubTotalAndTotal(
                              billDetails?.type === "Clinic"
                                ? treatTabList
                                : billDetails?.type === "Pharmacy"
                                  ? pharTabList
                                  : petShopTabList,
                            )?.subTotal,
                          )?.rounded,
                        ),
                      )?.toFixed(2)}
                    </Typography>
                  </>
                )}
              </div>
            </div>
          </div>
        )}
        <div className="flex-row mv10">
          {isBillSeparated &&
          (billDetails?.type === "Treatment" ||
            billDetails?.type === "Clinic") ? (
            <Typography
              className={`ml10 newTab cursor ${activeTab === "Treatment" ? "newTabSelected" : ""}`}
              onClick={() => setActiveTab("Treatment")}
            >
              {billDetails?.type === "Clinic" && !billDetails?.appointmentId
                ? "Clinic"
                : "Treatment"}
            </Typography>
          ) : null}
          {isBillSeparated &&
          !billDetails?.appointmentId &&
          billDetails?.type === "Pharmacy" ? (
            // ||(billDetails?.type === "Clinic" && billDetails?.estimate)
            <Typography
              className={`ml10 newTab cursor ${activeTab === "Pharmacy" ? "newTabSelected" : ""}`}
              onClick={() => setActiveTab("Pharmacy")}
            >
              Pharmacy
            </Typography>
          ) : null}
          {isBillSeparated &&
          !billDetails?.appointmentId &&
          billDetails?.type === "Pet Shop" ? (
            //  ||(billDetails?.type === "Clinic" && billDetails?.estimate)
            <Typography
              className={`ml10 newTab cursor ${activeTab === "Pet Shop" ? "newTabSelected" : ""}`}
              onClick={() => setActiveTab("Pet Shop")}
            >
              Pet Shop
            </Typography>
          ) : null}
          <div className="flex1-end">
            <div className="flex-row-ali-cen pr20">
              {activeTab === "Treatment" && billDetails?.appointmentId && (
                <div className="flex1-end">
                  <div className="flex-row-ali-cen">
                    <CustomSwitch
                      value={showValues?.showSublineItems}
                      onChange={(e) =>
                        onChangeShowValue(
                          "showSublineItems",
                          !showValues?.showSublineItems,
                        )
                      }
                      grayToBlue
                    />
                    <Typography className="font-medium fs14 black ml5">
                      Show sub-line items
                    </Typography>
                  </div>
                  <div className="flex-row-ali-cen ml15">
                    <CustomSwitch
                      value={showValues?.showSublinePrice}
                      onChange={(e) =>
                        onChangeShowValue(
                          "showSublinePrice",
                          !showValues?.showSublinePrice,
                        )
                      }
                      grayToBlue
                    />
                    <Typography className="font-medium fs14 black ml5">
                      Show prices for the sub-line items
                    </Typography>
                  </div>
                </div>
              )}
              {(billDetails?.type === "Treatment" ||
                billDetails?.type === "Pharmacy" ||
                billDetails?.type === "Pet Shop" ||
                (billDetails?.type === "Clinic" &&
                  !billDetails?.appointmentId)) &&
              billDetails?.checkOut !== "Y" ? (
                (billDetails?.type === "Pharmacy" &&
                  (billDetails?.amtPaid ?? 0)) ||
                (billDetails?.type === "Pet Shop" &&
                  (billDetails?.amtPaid ?? 0)) ? null : (
                  <>
                    <div className="cursor ml10" onClick={onDiscardBill}>
                      <div className="flex-center">
                        <DeleteOutlineIcon sx={delBtn} />
                      </div>
                      <Typography className="red3 fs8 txt-semi-bold text-align-center">
                        Discard
                      </Typography>
                    </div>
                    <div className="ml10">
                      <CustomButton
                        text="Save As Draft"
                        smallBtn
                        onClick={onNavBack}
                      />
                    </div>
                  </>
                )
              ) : null}

              {genBillVsble() ? (
                <div className="ml10">
                  <CustomButton
                    text="Finalize Bill"
                    smallBtn
                    onClick={() => onGenerateBill()}
                  />
                </div>
              ) : null}

              {getTabBasedRecords()?.length > 0 ? (
                <div
                  className="cursor ml10"
                  onClick={() => setPrntPrevVsble(true)}
                >
                  <div className="flex-center">
                    <PrintIcon sx={w20h20BlueIcon} />
                  </div>
                  <Typography className="blue-color fs8 txt-semi-bold text-align-center">
                    Print
                  </Typography>
                </div>
              ) : null}

              {(billDetails?.type === "Clinic" &&
                !billDetails?.appointmentId &&
                billDetails?.estimate) ||
              getTabBasedRecords()?.length === 0 ? null : (
                <div className="cursor ml10" onClick={handlePay}>
                  <div className="flex-center">
                    <AccountBalanceWalletIcon sx={w20h20GreenIcon} />
                  </div>
                  <Typography className="green4 fs8 txt-semi-bold text-align-center">
                    Pay
                  </Typography>
                </div>
              )}
            </div>
          </div>
        </div>
        {billDetails?.referenceNo?.length > 0 ? (
          <div className="flex-row-ali-cen mh20">
            <Typography className="font-bold fs12 black">
              Reference No:
            </Typography>
            <Typography className="font-bold fs12 gray4 ml5">
              {billDetails?.referenceNo}
            </Typography>
          </div>
        ) : null}

        <Container maxWidth="xl">
          <Box className="pb20 mt10 mh20Min" ref={searchAnchorRef}>
            <TableContainer sx={{ maxHeight: "auto" }}>
              <Table
                sx={{ minWidth: 200 }}
                aria-labelledby="tableTitle"
                stickyHeader
              >
                <TableHead>
                  <TableRow>
                    {phrTblHdrs?.map((hl, i) => (
                      <TableCell
                        key={i}
                        style={tblGrayBack}
                        sortDirection={false}
                        className={`table-header-text`}
                      >
                        <div
                          style={{
                            width:
                              hl === "serviceitemname"
                                ? 250
                                : hl === "discount"
                                  ? 100
                                  : hl === "qty" ||
                                      hl === "unitPrice" ||
                                      hl === "tax"
                                    ? 80
                                    : "auto",
                          }}
                        >
                          {tableNameExpan?.[hl]}
                        </div>
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {getTabBasedRecords()?.length > 0 &&
                    getTabBasedRecords()
                      ?.filter((pd) => pd?.type === "consultation")
                      ?.map((con) => {
                        const reqObj = {
                          serviceitemname: `Consultation(${billDetails?.appointmentType})`,
                          qty: con?.quantity,
                          unitPrice: `Rs ${
                            Number(con?.price) > 0
                              ? Number(con?.price).toFixed(2)
                              : Number(con?.price)
                          }`,
                          tax:
                            Number(con?.tax) > 0
                              ? Number(con?.tax).toFixed(2)
                              : "-",
                          total: `Rs ${Number(con?.total).toFixed(2)}`,
                          days: con?.days ?? "-",
                        };
                        if (deleteEditVisbile()) {
                          reqObj.pay = (
                            <div className="flex-row">
                              <div
                                className={
                                  activeTab === "Treatment" ? "" : "cursor"
                                }
                                onClick={() => {
                                  activeTab !== "Treatment" &&
                                    handleDelete(con);
                                }}
                              >
                                <div className="flex-center">
                                  <DeleteOutlineIcon sx={delBtn} />
                                </div>
                                <Typography className="red3 fs8 txt-semi-bold text-align-center">
                                  Delete
                                </Typography>
                              </div>
                              <div
                                className="cursor ml15"
                                onClick={() => handleEdit(con)}
                              >
                                <div className="flex-center">
                                  <EditIcon sx={w20h20BlueIcon} />
                                </div>
                                <Typography className="blue-color fs8 txt-semi-bold text-align-center">
                                  Edit
                                </Typography>
                              </div>
                            </div>
                          );
                        }
                        return reqObj;
                      })
                      ?.map((bil, ind) => (
                        <TableRow tabIndex={-1} key={ind}>
                          {phrTblHdrs?.map((th, index) => (
                            <TableCell
                              key={index + th + "tr"}
                              component="th"
                              className="table-text-black"
                            >
                              <div
                                className="upload-row"
                                style={{
                                  width:
                                    th === "serviceitemname"
                                      ? 250
                                      : th === "discount"
                                        ? 100
                                        : th === "qty" ||
                                            th === "unitPrice" ||
                                            th === "tax"
                                          ? 80
                                          : "auto",
                                }}
                              >
                                <div>{bil[th]}</div>
                              </div>
                            </TableCell>
                          ))}
                        </TableRow>
                      ))}
                  {getTabBasedRecords()?.length > 0 &&
                    (activeTab === "Treatment"
                      ? reorderList(treatTabList)
                      : activeTab === "Pet Shop"
                        ? petShopTabList
                        : pharTabList
                    )
                      ?.filter((pd) => pd?.type !== "consultation")
                      ?.map((bil) => {
                        let reqTax =
                          selectedItem?.paymentDetailId === bil?.paymentDetailId
                            ? Number(
                                (Number(
                                  itemValues?.mrpPrice ??
                                    itemValues?.price ??
                                    0,
                                ) /
                                  100) *
                                  Number(itemValues?.tax ?? 0) *
                                  Number(itemValues?.quantity),
                              )?.toFixed(2)
                            : bil?.tax;

                        const reqTotal = bil?.total;
                        const isProcedureSubItem =
                          (bil?.procedureId ?? "")?.toString()?.length > 0 &&
                          !bil?.mainProcedure &&
                          bil?.linked !== "N";
                        const reqObj = {
                          ...bil,
                          isProcedureSubItem,
                          serviceitemname: (
                            <div>
                              <div
                                className={`fs12 font-bold ${
                                  isProcedureSubItem ? "green2" : "black"
                                }`}
                              >
                                {bil?.serviceId
                                  ? removeDuplicateBracketText(
                                      bil?.tradeName ?? bil?.name,
                                    )
                                  : (bil?.tradeName ?? bil?.name)}
                              </div>
                              <div className="fs8 font-bold gray40 gray-back5 ph5 pv2 br5 con-fit mb3">
                                {bil?.patientWorkbook
                                  ? "Patient Workbook"
                                  : "Direct Bill"}
                              </div>
                            </div>
                          ),
                          qty: (
                            <div
                              className={`fs12 font-bold ${
                                isProcedureSubItem ? "green2" : "black"
                              }`}
                            >
                              {`${bil?.quantity}${
                                bil?.stockId && bil?.uomName?.length > 0
                                  ? getRightPackageUom(bil?.uomName, true)
                                  : ""
                              }`}
                            </div>
                          ),
                          unitPrice: (
                            <div
                              className={`fs12 font-bold ${
                                isProcedureSubItem ? "green2" : "black"
                              }`}
                            >{`Rs ${
                              Number(bil?.mrpPrice ?? bil?.price) > 0
                                ? Number(bil?.mrpPrice ?? bil?.price).toFixed(2)
                                : Number(bil?.mrpPrice ?? bil?.price)
                            }`}</div>
                          ),
                          discount:
                            Number(bil?.mrpDiscount ?? bil?.discount) > 0 ? (
                              <div
                                className={`fs12 font-bold ${
                                  isProcedureSubItem ? "green2" : "black"
                                }`}
                              >{`Rs ${Number(
                                bil?.mrpDiscount ?? bil?.discount,
                              ).toFixed(2)}`}</div>
                            ) : (
                              "-"
                            ),
                          total: (
                            <div
                              className={`fs12 font-bold ${
                                isProcedureSubItem ? "green2" : "black"
                              }`}
                            >{`Rs ${Number(bil?.reqTotal).toFixed(2)}`}</div>
                          ),
                          days: bil?.days ?? "-",
                          variantId: bil?.variantId ?? null,
                          serviceId: bil?.serviceId ?? null,
                        };
                        if (deleteEditVisbile()) {
                          reqObj.pay = (
                            <div className="flex-row">
                              <div
                                className="cursor"
                                onClick={() => handleDelete(bil)}
                              >
                                <div className="flex-center">
                                  <DeleteOutlineIcon sx={delBtn} />
                                </div>
                                <Typography className="red3 fs8 txt-semi-bold text-align-center">
                                  Delete
                                </Typography>
                              </div>
                              <div
                                className="cursor ml15"
                                onClick={() => handleEdit(bil)}
                              >
                                <div className="flex-center">
                                  <EditIcon sx={w20h20BlueIcon} />
                                </div>
                                <Typography className="blue-color fs8 txt-semi-bold text-align-center">
                                  Edit
                                </Typography>
                              </div>
                            </div>
                          );
                        }
                        reqObj.reqTotal =
                          selectedItem?.paymentDetailId ===
                            bil?.paymentDetailId && editVisible
                            ? Number(reqTotal)
                            : (reqTotal ?? bil?.total);
                        reqObj.productId = itemValues?.productId;
                        reqObj.tax =
                          reqTax > 0 ? (
                            <div
                              className={`fs12 font-bold ${
                                isProcedureSubItem ? "green2" : "black"
                              }`}
                            >{`Rs ${Number(reqTax).toFixed(2)}`}</div>
                          ) : (
                            "-"
                          );
                        return reqObj;
                      })
                      ?.map((bil, ind) => {
                        const reqList = bil?.reqList;
                        return (
                          <>
                            <TableRow tabIndex={-1} key={ind}>
                              {phrTblHdrs?.map((th, index) => {
                                return (
                                  <TableCell
                                    key={index + th + "tr"}
                                    component="th"
                                    className="table-text-black"
                                  >
                                    <div
                                      className="upload-row"
                                      style={{
                                        width:
                                          th === "serviceitemname"
                                            ? 250
                                            : th === "discount"
                                              ? 100
                                              : th === "qty" ||
                                                  th === "unitPrice" ||
                                                  th === "tax"
                                                ? 80
                                                : "auto",
                                      }}
                                    >
                                      <div>
                                        {th === "serviceitemname" ? (
                                          <div>
                                            {bil?.[th]}
                                            {bil?.stockId && (
                                              <div>
                                                {/* <div className="fs10 gray4 font-medium">
                                                  Generic Name:{" "}
                                                  {bil?.name ?? ""}
                                                </div> */}
                                                <div className="fs10 gray4 font-medium">
                                                  Batch No.:{" "}
                                                  {bil?.batchNo ?? ""} Expiry:{" "}
                                                  {bil?.expiryDate?.length > 0
                                                    ? moment(
                                                        new Date(
                                                          bil?.expiryDate,
                                                        ),
                                                      )?.format("DD MMM YYYY")
                                                    : ""}
                                                </div>
                                                {bil?.drugSchedule?.length >
                                                0 ? (
                                                  <div className="fs10 gray4 font-medium">
                                                    Drug Schedule:{" "}
                                                    {bil?.drugSchedule ?? ""}
                                                  </div>
                                                ) : null}
                                              </div>
                                            )}
                                          </div>
                                        ) : th === "total" ? (
                                          <div
                                            className={`fs12 font-bold ${
                                              bil?.isProcedureSubItem
                                                ? "green2"
                                                : "black"
                                            }`}
                                          >{`Rs ${Number(bil?.reqTotal).toFixed(
                                            2,
                                          )}`}</div>
                                        ) : typeof bil?.[th] === "number" ? (
                                          Number(bil?.[th]).toFixed(2)
                                        ) : (
                                          bil?.[th]
                                        )}
                                      </div>
                                    </div>
                                  </TableCell>
                                );
                              })}
                            </TableRow>
                            {activeTab === "Treatment" &&
                              reqList?.map((itm) => {
                                const isDone = bil?.variantId
                                  ? true
                                  : itm?.status === "true";
                                return (
                                  <TableRow tabIndex={-1} key={ind}>
                                    {phrTblHdrs?.map((th, index) => (
                                      <TableCell
                                        key={index + th + "tr"}
                                        component="th"
                                        className="table-text-black"
                                      >
                                        <div
                                          className="upload-row"
                                          style={{
                                            width:
                                              th === "serviceitemname"
                                                ? 250
                                                : th === "discount"
                                                  ? 100
                                                  : th === "qty" ||
                                                      th === "unitPrice" ||
                                                      th === "tax"
                                                    ? 80
                                                    : "auto",
                                          }}
                                        >
                                          <div
                                            className={
                                              isDone
                                                ? "green-color"
                                                : "red-color"
                                            }
                                          >
                                            {th === "qty" ? (
                                              itm?.[th]
                                            ) : th === "total" ||
                                              th ===
                                                "discount" ? null : typeof itm?.[
                                                th
                                              ] === "number" ? (
                                              `Rs ${Number(itm?.[th]).toFixed(
                                                2,
                                              )}`
                                            ) : th === "serviceitemname" ? (
                                              <div className="flex-row-ali-cen">
                                                {isDone ? (
                                                  <img
                                                    src={require("../../../../assets/images/png/tick.png")}
                                                    className="img-wh15"
                                                  />
                                                ) : (
                                                  <img
                                                    src={require("../../../../assets/images/png/crossRed.png")}
                                                    className="img-wh15"
                                                  />
                                                )}
                                                <div className="pl10">
                                                  {itm?.[th]}
                                                </div>
                                              </div>
                                            ) : (
                                              itm?.[th]
                                            )}
                                          </div>
                                        </div>
                                      </TableCell>
                                    ))}
                                  </TableRow>
                                );
                              })}
                          </>
                        );
                      })}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </Container>

        {searchVisible && searchOverlayStyle ? (
          <div className="billing-search-overlay" style={searchOverlayStyle}>
            <div className="billing-search-panel">
              <div className="billing-search-panel-header">
                <div className="billing-search-field">
                  <CustomTextField
                    placeholder="Search"
                    fullWidth
                    autoFocus
                    handleChange={(e) => setSearchValue(e?.target?.value)}
                    value={searchValue}
                  />
                </div>
                <CloseIcon className="cursor" onClick={closeSearchOverlay} />
              </div>
              {searchValue?.length > 0 ? (
                <div className="billing-search-results">
                  <div className="flex-row mv5">
                    <div className="w25Per">
                      <Typography className="txt-regular fs14 blue-color">
                        Name
                      </Typography>
                    </div>
                    <div className="w10Per">
                      <Typography className="txt-regular fs14 blue-color">
                        Type
                      </Typography>
                    </div>
                    <div className="w15Per">
                      <Typography className="txt-regular fs14 blue-color">
                        Available Qty
                      </Typography>
                    </div>
                    <div className="w20Per">
                      <Typography className="txt-regular fs14 blue-color">
                        Category
                      </Typography>
                    </div>
                    <div className="w20Per">
                      <Typography className="txt-regular fs14 blue-color">
                        Price
                      </Typography>
                    </div>
                    <div className="w10Per">
                      <Typography className="txt-regular fs14 blue-color">
                        Status
                      </Typography>
                    </div>
                  </div>
                  {filteredSearchList?.length > 0 ? (
                    <div className="billing-search-results-list">
                      {filteredSearchList?.map((fil, i) => {
                        const reqStatus = (() => {
                          if (fil?.serviceId) return null;
                          const expiryDate = fil?.stockBatch?.filter(
                            (btch) =>
                              btch?.createdBy === clinicDet?.id &&
                              btch?.approved,
                          )?.[0]?.expiryDate;
                          if (!expiryDate?.length) return null;
                          const today = moment().startOf("day");
                          const expiry = moment(new Date(expiryDate)).startOf(
                            "day",
                          );
                          if (expiry.isBefore(today)) return "expired";
                          if (expiry.diff(today, "days") < 30) {
                            return "nearExpiry";
                          }
                          return null;
                        })();
                        return (
                          <div
                            className="bill-itm cursor"
                            key={i + "fil"}
                            onClick={() => handleAddItem(fil)}
                          >
                            <div className="w25Per">
                              <Typography className="txt-regular fs14">
                                {fil?.name}
                              </Typography>
                            </div>
                            <div className="w10Per">
                              <Typography className="txt-regular fs14">
                                {fil?.type}
                              </Typography>
                            </div>
                            <div className="w15Per">
                              <Typography className="txt-regular fs14">
                                {fil?.availableQty}
                              </Typography>
                            </div>
                            <div className="w20Per">
                              <Typography className="txt-regular fs14">
                                {fil?.category}
                              </Typography>
                            </div>
                            <div className="w20Per">
                              <Typography className="txt-regular fs14">
                                {(fil?.servicePrice ??
                                fil?.stockBatch?.filter(
                                  (btch) =>
                                    btch?.createdBy === clinicDet?.id &&
                                    btch?.approved,
                                )?.[0]?.unitSellingPrice)
                                  ? `Rs ${Number(
                                      fil?.servicePrice ??
                                        fil?.stockBatch?.filter(
                                          (btch) =>
                                            btch?.createdBy === clinicDet?.id &&
                                            btch?.approved,
                                        )?.[0]?.unitSellingPrice,
                                    ).toFixed(2)}`
                                  : "-"}
                              </Typography>
                            </div>
                            <div className="w10Per">
                              {reqStatus ? (
                                <div
                                  className={`con-fit fs12 white-color ph10 pv2 br5 ${
                                    reqStatus === "expired"
                                      ? "card-bot-red-back"
                                      : "card-top-yellow-color"
                                  }`}
                                >
                                  {reqStatus === "expired"
                                    ? "Expired"
                                    : "Near Expiry"}
                                </div>
                              ) : null}
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  ) : (
                    <div className="flex-center mt20">
                      <Typography className="txt-regular">
                        No records available
                      </Typography>
                    </div>
                  )}

                  {/* {filteredSearchList?.length > 0 ? null : (
                    <div className="flex-row flex-center">
                      <div className="flex-start">
                        <Typography className="fs14">{searchValue}</Typography>
                      </div>
                      <div className="flex1-end mt20">
                        <div className="w15Per">
                          <CustomButton
                            text="Add New"
                            smallBtn
                            onClick={() => handleAddItem()}
                          />
                        </div>
                      </div>
                    </div>
                  )} */}
                </div>
              ) : null}
            </div>
          </div>
        ) : null}
        <div className="flex-row mt20">
          <div>
            {deleteEditVisbile() ? (
              <div className="flex-row ph10">
                <div>
                  <CustomButton
                    text="Add"
                    smallBtn
                    disabled={isAddingItems}
                    onClick={openAddItemModal}
                  />
                </div>
                <div className="ml15">
                  <CustomButton
                    text={`${
                      Number(billDetails?.treatmentDiscountValue ?? 0) > 0
                        ? "Edit"
                        : "Apply"
                    } Discount`}
                    smallBtn
                    onClick={handleApplyDiscount}
                  />
                </div>
              </div>
            ) : null}

            {genBillVsble() ? (
              <div className="flex-row ph10 mt20">
                {billDetails?.type === "Pharmacy" ? (
                  <div className="w200Px">
                    <CustomSelect
                      list={getVetList()}
                      value={billedByValues?.vet ?? null}
                      search
                      label="Vet Name"
                      handleChange={(e, value) => {
                        onChangeBilledBy("vet", value, "vetError");
                      }}
                      error={billedByValues?.vetError ?? false}
                      helperText={
                        billedByValues?.vetError ? "This field is required" : ""
                      }
                    />
                  </div>
                ) : null}
                <div
                  className={`w200Px ${billDetails?.type === "Pharmacy" ? "ml15" : ""}`}
                >
                  <CustomSelect
                    list={getBilledByList()}
                    value={billedByValues?.billedBy ?? null}
                    search
                    label="Billed By"
                    handleChange={(e, value) => {
                      onChangeBilledBy("billedBy", value, "error");
                    }}
                    error={billedByValues?.error ?? false}
                    helperText={
                      billedByValues?.error ? "This field is required" : ""
                    }
                  />
                </div>
              </div>
            ) : null}
            {billDetails?.estimate ||
            genBillVsble() ||
            billDetails?.checkOut === "Y" ? (
              <div className="ph10 mt15" style={{ minWidth: 480 }}>
                <CustomTextField
                  label="Remarks"
                  name="billRemarks"
                  fullWidth
                  multiline
                  rows={3}
                  handleChange={(e) => setBillRemarks(e?.target?.value ?? "")}
                  value={billRemarks}
                  disabled={billDetails?.checkOut === "Y"}
                />
              </div>
            ) : null}
          </div>

          <div className="flex1-end ph20 mtMin5">
            <div className="w100Per flex-column">
              <div className="flex1-end">
                <div className="w40Per">
                  <div className="flex-row-between-align-center">
                    <div className="fs14 txt-regular">Discount</div>
                    <div className="fs14 txt-regular">
                      {Number(
                        (activeTab === "Treatment"
                          ? getTaxAndSubTotalAndTotal(treatTabList)
                          : activeTab === "Pharmacy"
                            ? getTaxAndSubTotalAndTotal(pharTabList)
                            : getTaxAndSubTotalAndTotal(petShopTabList)
                        )?.discount,
                      ) > 0
                        ? `Rs ${Number(
                            (activeTab === "Treatment"
                              ? getTaxAndSubTotalAndTotal(treatTabList)
                              : activeTab === "Pharmacy"
                                ? getTaxAndSubTotalAndTotal(pharTabList)
                                : getTaxAndSubTotalAndTotal(petShopTabList)
                            )?.discount,
                          )?.toFixed(2)}`
                        : "-"}
                    </div>
                  </div>
                  <div className="flex-row-between-align-center">
                    <div className="fs14 txt-regular">
                      {isBillSeparated
                        ? activeTab === "Treatment"
                          ? "Treatment"
                          : activeTab === "Pet Shop"
                            ? "Pet Shop"
                            : "Pharmacy"
                        : ""}{" "}
                      Subtotal
                    </div>
                    <div className="fs14 txt-regular">
                      Rs{" "}
                      {Number(
                        Number(
                          getTaxAndSubTotalAndTotal(
                            activeTab === "Treatment"
                              ? treatTabList
                              : activeTab === "Pet Shop"
                                ? petShopTabList
                                : pharTabList,
                          )?.subTotalNew,
                        ),
                      )?.toFixed(2)}
                    </div>
                  </div>
                  <div className="flex-row-between-align-center">
                    <div className="fs14 txt-regular">Taxes (CGST) </div>
                    <div className="fs14 txt-regular">
                      {Number(
                        getTaxAndSubTotalAndTotal(
                          activeTab === "Pet Shop"
                            ? petShopTabList
                            : activeTab === "Pharmacy"
                              ? pharTabList
                              : treatTabList,
                        )?.tax,
                      ) /
                        2 >
                      0
                        ? `Rs ${Number(
                            Number(
                              getTaxAndSubTotalAndTotal(
                                activeTab === "Pet Shop"
                                  ? petShopTabList
                                  : activeTab === "Pharmacy"
                                    ? pharTabList
                                    : treatTabList,
                              )?.tax,
                            ) / 2,
                          )?.toFixed(2)}`
                        : "-"}
                    </div>
                  </div>
                  <div className="flex-row-between-align-center">
                    <div className="fs14 txt-regular">Taxes (SGST) </div>
                    <div className="fs14 txt-regular">
                      {Number(
                        getTaxAndSubTotalAndTotal(
                          activeTab === "Pet Shop"
                            ? petShopTabList
                            : activeTab === "Pharmacy"
                              ? pharTabList
                              : treatTabList,
                        )?.tax,
                      ) /
                        2 >
                      0
                        ? `Rs ${Number(
                            Number(
                              getTaxAndSubTotalAndTotal(
                                activeTab === "Pet Shop"
                                  ? petShopTabList
                                  : activeTab === "Pharmacy"
                                    ? pharTabList
                                    : treatTabList,
                              )?.tax,
                            ) / 2,
                          )?.toFixed(2)}`
                        : "-"}
                    </div>
                  </div>
                  <div className="flex-row-between-align-center">
                    <div className="fs14 txt-regular">Round Off</div>
                    <div className="fs14 txt-regular">
                      Rs{" "}
                      {
                        roundWithSignedDiff(
                          Number(
                            (activeTab === "Treatment"
                              ? getTaxAndSubTotalAndTotal(treatTabList)
                              : getTaxAndSubTotalAndTotal(
                                  activeTab === "Pet Shop"
                                    ? petShopTabList
                                    : pharTabList,
                                )
                            )?.subTotal,
                          ),
                        )?.difference
                      }
                    </div>
                  </div>
                  <div className="flex-row-between-align-center">
                    <div className="txt-semi-bold fs14 blue-color">
                      {isBillSeparated
                        ? activeTab === "Treatment"
                          ? "Treatment "
                          : activeTab === "Pet Shop"
                            ? "Pet Shop "
                            : "Pharmacy "
                        : ""}
                      Total
                    </div>
                    <div className="txt-semi-bold fs14 blue-color">
                      Rs{" "}
                      {roundWithSignedDiff(
                        Number(
                          (activeTab === "Treatment"
                            ? getTaxAndSubTotalAndTotal(treatTabList)
                            : getTaxAndSubTotalAndTotal(
                                activeTab === "Pet Shop"
                                  ? petShopTabList
                                  : pharTabList,
                              )
                          )?.subTotal,
                        ),
                      )?.rounded?.toFixed(2)}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="billing-change-log mt20 mb20 ph20">
          <Typography className="font-bold fs14 black mb10">
            Change Log
          </Typography>
          <TableContainer>
            <Table size="small">
              <TableHead>
                <TableRow style={tblGrayBack}>
                  <TableCell className="table-text-black">
                    <Typography className="fs12 font-bold">
                      Date and Time
                    </Typography>
                  </TableCell>
                  <TableCell className="table-text-black">
                    <Typography className="fs12 font-bold">Action</Typography>
                  </TableCell>
                  <TableCell className="table-text-black">
                    <Typography className="fs12 font-bold">Changes</Typography>
                  </TableCell>
                  <TableCell className="table-text-black">
                    <Typography className="fs12 font-bold">
                      Performed by
                    </Typography>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {paymentLogRows.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={4} className="table-text-black">
                      <Typography className="fs12 gray4 flex-center pv10">
                        No change log available
                      </Typography>
                    </TableCell>
                  </TableRow>
                ) : (
                  paymentLogRows.map((row) => (
                    <TableRow key={row.key}>
                      <TableCell className="table-text-black">
                        <Typography className="fs12">
                          {row.createdDate
                            ? moment(row.createdDate).format(
                                "DD MMM YYYY, hh:mm A",
                              )
                            : "-"}
                        </Typography>
                      </TableCell>
                      <TableCell className="table-text-black">
                        <Typography
                          className={`fs12 font-medium ${
                            row.action === "Deleted"
                              ? "red-color"
                              : row.action === "Updated" ||
                                  row.action === "Discount updated"
                                ? "blue-color"
                                : row.action === "Opening"
                                  ? "orange-color"
                                  : row.action === "Closed" ||
                                      row.action === "Closing"
                                    ? "purple"
                                    : row.action === "Reopened"
                                      ? "yellow-color"
                                      : "green-color"
                          }`}
                        >
                          {row.action}
                        </Typography>
                      </TableCell>
                      <TableCell className="table-text-black">
                        <Typography className="fs12">{row.changes}</Typography>
                      </TableCell>
                      <TableCell className="table-text-black">
                        <Typography className="fs12">
                          {row.performedBy}
                        </Typography>
                      </TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      </div>
      {prntPrevVsble ? (
        <BillingPreview
          selectedBill={billDetails}
          modVsble={prntPrevVsble}
          onClosePreview={() => {
            setPrntPrevVsble(false);
          }}
          billsToShow={[
            activeTab === "Treatment"
              ? "treatment"
              : activeTab === "Pharmacy"
                ? "pharmacy"
                : "petshop",
          ]}
        />
      ) : null}
      {payModalVisible ? (
        <CommonPayModal
          modVsble={payModalVisible}
          selectedBill={getCorrectedBillDetails()}
          billsToShow={["TREATMENT", "PHARMACY", "PETSHOP"]}
          onCloseMod={payModClose}
          selectedTab={payTabEnum?.[activeTab]}
        />
      ) : null}
      {depositVsble ? (
        <CollectDeposit
          modVsble={depositVsble}
          payment={billDetails}
          onCloseMod={onCollectClose}
          tab={billingTabEnum?.[activeTab]}
        />
      ) : null}
      <CustomModal
        open={genBillModVsble}
        onClose={onCloseGenBillMod}
        header="Close Bill"
        modal
        modalWidth={35}
        headerBold
      >
        <div className="mh20 mb30">
          <div className="txt-semi-bold fs16">
            Are you sure you want to close this bill?
          </div>
          <div className="fs14 font-medium">
            No further changes will be allowed after this step.
          </div>
          <div className="fs14 txt-semi-bold mt20">Payment Summary:</div>
          {petAndApntData?.appointment?.inpatient &&
          petAndApntData?.inpatientResponse?.patientId &&
          Number(petAndApntData?.inpatientResponse?.depositAmount) > 0 ? (
            <div className="fs14 font-medium">
              Non-refundable deposit:{" "}
              {Number(
                petAndApntData?.inpatientResponse?.depositAmount,
              )?.toFixed(2)}
            </div>
          ) : null}
          {Number(amtPaidByTab?.[activeTab] ?? 0) <
          Number(totalByTab?.[activeTab] ?? 0) ? (
            <>
              <div className="fs14 font-medium">
                Unapplied credit to be used:{" "}
                {Number(amtPaidByTab?.[activeTab]) > 0
                  ? Number(amtPaidByTab?.[activeTab])?.toFixed(2)
                  : amtPaidByTab?.[activeTab]}
              </div>
              <div className="fs14 font-medium">
                Remaining balance due:{" "}
                {Number(
                  Number(totalByTab?.[activeTab] ?? 0) -
                    (Number(amtPaidByTab?.[activeTab] ?? 0) +
                      Number(
                        petAndApntData?.inpatientResponse?.depositAmount ?? 0,
                      )),
                )?.toFixed(2)}
              </div>
            </>
          ) : Number(amtPaidByTab?.[activeTab] ?? 0) ===
            Number(totalByTab?.[activeTab] ?? 0) ? (
            <>
              <div className="fs14 font-medium">
                Full invoice total will be settled using available credit of:{" "}
                {Number(amtPaidByTab?.[activeTab])?.toFixed(2)}
              </div>
            </>
          ) : Number(amtPaidByTab?.[activeTab] ?? 0) >
            Number(totalByTab?.[activeTab] ?? 0) ? (
            <>
              <div className="fs14 font-medium">
                Unapplied credit to be used:{" "}
                {Number(totalByTab?.[activeTab])?.toFixed(2)}
              </div>
              <div className="fs14 font-medium">Remaining balance due: 0</div>
              <div className="fs14 font-medium red-color">
                Excess of{" "}
                {Number(
                  Number(amtPaidByTab?.[activeTab] ?? 0) -
                    Number(totalByTab?.[activeTab] ?? 0),
                )?.toFixed(2)}{" "}
                will be moved to customer credits.
              </div>
            </>
          ) : null}

          {/* <div className="flex-center fs14 font-medium">
            Please confirm to proceed.
          </div> */}
          <div className="flex-row-ali-cen flex-center mt20">
            <div>
              <CustomButton
                text="Confirm"
                redBtn
                smallBtn
                onClick={() => onGenerateBill(false)}
              />
            </div>
            <div className="ml20">
              <CustomButton
                text="Cancel"
                smallBtn
                onClick={onCloseGenBillMod}
              />
            </div>
          </div>
        </div>
      </CustomModal>

      <CustomModal
        open={editModVsble}
        onClose={onCloseEditMod}
        header="Edit"
        rightModal
        modalWidth={30}
      >
        <div className="scroll-90vh ph10">
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <Typography className="font-bold fs14 gray4">
                Sevice / Item Name
              </Typography>
              <CustomTextField
                value={itemValues?.name}
                handleChange={(e) =>
                  onChangeItemValue("name", e?.target?.value)
                }
                fullWidth
                disabled
              />
            </Grid>
            {isProcedurePresent() ? (
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Typography className="font-bold fs14 gray4">
                  Link To Procedure
                </Typography>
                <CustomSelect
                  list={getProcedureList()}
                  value={
                    itemValues?.linkToProcedure ??
                    getProcedureList()?.[0] ??
                    null
                  }
                  handleChange={(e, value) => {
                    onChangeItemValue(
                      "linkToProcedure",
                      value?.apiValue ? value : null,
                    );
                  }}
                  search
                />
              </Grid>
            ) : null}
            <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
              <Typography className="font-bold fs14 gray4">Quantity</Typography>
              <CustomTextField
                value={itemValues?.quantity}
                handleChange={(e) =>
                  onChangeItemValue("quantity", e?.target?.value)
                }
                fullWidth
                type="number"
                error={
                  !!(
                    itemValues?.qtyLimitErr ||
                    (itemValues?.stockId &&
                      getStockQuantityError(itemValues, { forEdit: true }))
                  )
                }
                helperText={
                  itemValues?.qtyLimitErr ||
                  (itemValues?.stockId
                    ? getStockQuantityError(itemValues, { forEdit: true })
                    : "")
                }
              />
            </Grid>
            {itemValues?.stockId ? (
              <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                <Typography className="font-bold fs14 gray4">UOM</Typography>
                <CustomSelect
                  list={getUOMListByStockId(itemValues?.stockId)}
                  value={itemValues?.uom}
                  handleChange={(e, value) => {
                    onChangeItemValue("uom", value);
                  }}
                  search
                />
              </Grid>
            ) : null}
            <Grid
              item
              xs={12}
              sm={12}
              md={itemValues?.stockId ? 12 : 6}
              lg={itemValues?.stockId ? 12 : 6}
              xl={itemValues?.stockId ? 12 : 6}
            >
              <Typography className="font-bold fs14 gray4">
                Unit Price
              </Typography>
              <CustomTextField
                value={itemValues?.price}
                handleChange={(e) =>
                  onChangeItemValue("price", e?.target?.value)
                }
                fullWidth
                type="number"
                disabled={
                  !itemValues?.batchId &&
                  !itemValues?.stockId &&
                  !itemValues?.productId
                    ? false
                    : true
                }
              />
            </Grid>
            {itemValues?.stockId ? (
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Typography className="font-bold fs14 gray4">
                  Batch Number
                </Typography>
                <CustomSelect
                  list={getBatches(itemValues?.stockId)}
                  value={itemValues?.batchNumber}
                  handleChange={(e, value) => {
                    onChangeItemValue("batchNumber", value);
                  }}
                  search
                  isBatchNumber
                />
              </Grid>
            ) : null}
            <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
              <Typography className="font-bold fs14 gray4">
                Unit Discount
              </Typography>
              {itemValues?.discountType?.value === "code" ? (
                <CustomSelect
                  list={getDiscountCodes()}
                  name="discountValue"
                  value={itemValues?.discountValue}
                  handleChange={(e, value) =>
                    onChangeItemValue("discountValue", value)
                  }
                  search
                  error={getTaxDiscountAndTotal(itemValues)?.isHigherDiscount}
                  helperText={
                    getTaxDiscountAndTotal(itemValues)?.isHigherDiscount
                      ? "Discount cannot be greater than unit price"
                      : ""
                  }
                  disabled={
                    activeTab === "Treatment" &&
                    itemValues?.linkToProcedure?.apiValue
                  }
                />
              ) : (
                <CustomTextField
                  name="discountValue"
                  fullWidth
                  handleChange={(e) =>
                    onChangeItemValue("discountValue", e?.target?.value)
                  }
                  value={itemValues?.discountValue}
                  type="number"
                  error={getTaxDiscountAndTotal(itemValues)?.isHigherDiscount}
                  helperText={
                    getTaxDiscountAndTotal(itemValues)?.isHigherDiscount
                      ? "Discount cannot be greater than unit price"
                      : ""
                  }
                  mandatoryField
                  disabled={
                    activeTab === "Treatment" &&
                    itemValues?.linkToProcedure?.apiValue
                  }
                />
              )}
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
              <Typography className="font-bold fs14 gray4">
                Discount Type
              </Typography>
              <CustomSelect
                list={dropDiscountTypes}
                value={itemValues?.discountType}
                handleChange={(e, value) => {
                  onChangeItemValue("discountType", value);
                }}
                search
                disabled={
                  activeTab === "Treatment" &&
                  itemValues?.linkToProcedure?.apiValue
                }
              />
            </Grid>
            <div className="flex-row-between-align-center pl20 w100Per mt15">
              <Typography className="txt-semi-bold fs14 gray17">
                Discount
              </Typography>
              <Typography className="txt-semi-bold fs14 gray17 pr20">
                {Number(getTaxDiscountAndTotal(itemValues)?.discount) > 0
                  ? `Rs. ${Number(
                      getTaxDiscountAndTotal(itemValues)?.discount,
                    ).toFixed(2)}`
                  : "-"}
              </Typography>
            </div>
            <div className="flex-row-between-align-center pl20 w100Per mt15">
              <Typography className="txt-semi-bold fs14 gray17">Tax</Typography>
              <Typography className="txt-semi-bold fs14 gray17 pr20">
                {Number(getTaxDiscountAndTotal(itemValues)?.tax) > 0
                  ? `Rs. ${Number(
                      getTaxDiscountAndTotal(itemValues)?.tax,
                    ).toFixed(2)}`
                  : "-"}
              </Typography>
            </div>
            <div className="flex-row-between-align-center pl20 w100Per mt15">
              <Typography className="txt-semi-bold fs14 blue-color">
                Item Total
              </Typography>
              <Typography className="txt-semi-bold fs14 blue-color pr20">
                {Number(getTaxDiscountAndTotal(itemValues)?.total) > 0
                  ? `Rs. ${Number(
                      getTaxDiscountAndTotal(itemValues)?.total,
                    )?.toFixed(2)}`
                  : "-"}
              </Typography>
            </div>
          </Grid>
          <div className="flex1-center mv20">
            <div>
              <CustomButton
                text="Update"
                smallBtn
                onClick={() => handleUpdateItem(itemValues)}
              />
            </div>
          </div>
        </div>
      </CustomModal>

      <CustomModal
        open={addModVsble}
        onClose={onCloseAddMod}
        header="Add Item"
        modal
        modalWidth={40}
        reduceHeaderSize
        hideClose
      >
        <Box
          display="flex"
          flexDirection="column"
          sx={{ height: "calc(100vh - 75px)" }}
        >
          <Box p={3} flexGrow={1} overflow="auto">
            <Box mb={2.5}>
              <Typography
                sx={{
                  fontSize: "11px",
                  fontWeight: 700,
                  color: "#616161",
                  letterSpacing: "0.5px",
                  mb: 1,
                  textTransform: "uppercase",
                }}
              >
                SERVICE / ITEM NAME
              </Typography>
              <SearchableSelect
                variant="procedure"
                list={getAddItemSelectList() ?? []}
                value={itemValues?.name}
                error={!!addItemErrs?.name || itemValues?.nameErr}
                helperText={
                  addItemErrs?.name || itemValues?.nameErr ? "Required" : ""
                }
                mandatoryField
                isForBilling
                allowAddNew={false}
                handleChange={(e, value) => onSelectAddCatalogItem(value)}
                maxFilteredOptions={100}
                placeholder="Search service / item..."
              />
            </Box>

            {isProcedurePresent() ? (
              <Box mb={2.5}>
                <Typography
                  sx={{
                    fontSize: "11px",
                    fontWeight: 700,
                    color: "#616161",
                    letterSpacing: "0.5px",
                    mb: 1,
                    textTransform: "uppercase",
                  }}
                >
                  LINK TO PROCEDURE
                </Typography>
                <CustomSelect
                  list={getProcedureList()}
                  value={
                    itemValues?.linkToProcedure ??
                    getProcedureList()?.[0] ??
                    null
                  }
                  handleChange={(e, value) => {
                    onChangeItemValue(
                      "linkToProcedure",
                      value?.apiValue ? value : null,
                    );
                  }}
                  search
                />
              </Box>
            ) : null}

            <Grid container spacing={2} mb={2.5}>
              <Grid item xs={itemValues?.stockId ? 6 : 12}>
                <Typography
                  sx={{
                    fontSize: "11px",
                    fontWeight: 700,
                    color: "#616161",
                    letterSpacing: "0.5px",
                    mb: 1,
                    textTransform: "uppercase",
                  }}
                >
                  QUANTITY
                </Typography>
                <CustomTextField
                  value={itemValues?.quantity}
                  handleChange={(e) =>
                    onChangeItemValue("quantity", e?.target?.value)
                  }
                  fullWidth
                  type="number"
                  error={
                    !!(
                      itemValues?.qtyLimitErr ||
                      (itemValues?.stockId &&
                        getStockQuantityError(itemValues)) ||
                      addItemErrs?.quantity ||
                      itemValues?.qtyErr
                    )
                  }
                  helperText={
                    itemValues?.qtyLimitErr ||
                    (itemValues?.stockId
                      ? getStockQuantityError(itemValues)
                      : "") ||
                    addItemErrs?.quantity ||
                    (itemValues?.qtyErr ? "This field is required" : "")
                  }
                />
              </Grid>
              {itemValues?.stockId ? (
                <Grid item xs={6}>
                  <Typography
                    sx={{
                      fontSize: "11px",
                      fontWeight: 700,
                      color: "#616161",
                      letterSpacing: "0.5px",
                      mb: 1,
                      textTransform: "uppercase",
                    }}
                  >
                    UOM
                  </Typography>
                  <CustomSelect
                    list={
                      getAddedBatchUomList(
                        itemValues?.stockId,
                        itemValues?.batchNumber?.batchId ??
                          itemValues?.batchNumber?.value ??
                          itemValues?.batchId,
                      ) ?? []
                    }
                    value={itemValues?.uom}
                    handleChange={(e, value) => {
                      onChangeItemValue("uom", value);
                    }}
                    search
                  />
                </Grid>
              ) : null}
            </Grid>

            <Box mb={2.5}>
              <Typography
                sx={{
                  fontSize: "11px",
                  fontWeight: 700,
                  color: "#616161",
                  letterSpacing: "0.5px",
                  mb: 1,
                  textTransform: "uppercase",
                }}
              >
                UNIT PRICE
              </Typography>
              <CustomTextField
                value={itemValues?.price}
                handleChange={(e) =>
                  onChangeItemValue("price", e?.target?.value)
                }
                fullWidth
                type="number"
                disabled={
                  !itemValues?.batchId &&
                  !itemValues?.stockId &&
                  !itemValues?.productId
                    ? false
                    : true
                }
              />
            </Box>

            {itemValues?.stockId ? (
              <Box mb={2.5}>
                <Typography
                  sx={{
                    fontSize: "11px",
                    fontWeight: 700,
                    color: "#616161",
                    letterSpacing: "0.5px",
                    mb: 1,
                    textTransform: "uppercase",
                  }}
                >
                  BATCH NUMBER
                </Typography>
                <CustomSelect
                  list={getBatches(itemValues?.stockId) ?? []}
                  value={itemValues?.batchNumber}
                  handleChange={(e, value) => {
                    onChangeItemValue("batchNumber", value);
                  }}
                  search
                  isBatchNumber
                  error={!!addItemErrs?.batchNumber || itemValues?.batchErr}
                  helperText={
                    addItemErrs?.batchNumber || itemValues?.batchErr
                      ? "Please select a batch number"
                      : ""
                  }
                />
              </Box>
            ) : null}

            <Grid container spacing={2} mb={2.5}>
              <Grid item xs={6}>
                <Typography
                  sx={{
                    fontSize: "11px",
                    fontWeight: 700,
                    color: "#616161",
                    letterSpacing: "0.5px",
                    mb: 1,
                    textTransform: "uppercase",
                  }}
                >
                  UNIT DISCOUNT
                </Typography>
                {itemValues?.discountType?.value === "code" ? (
                  <CustomSelect
                    list={getDiscountCodes()}
                    name="discountValue"
                    value={itemValues?.discountValue}
                    handleChange={(e, value) =>
                      onChangeItemValue("discountValue", value)
                    }
                    search
                    error={getTaxDiscountAndTotal(itemValues)?.isHigherDiscount}
                    helperText={
                      getTaxDiscountAndTotal(itemValues)?.isHigherDiscount
                        ? "Discount cannot be greater than unit price"
                        : ""
                    }
                    disabled={
                      activeTab === "Treatment" &&
                      itemValues?.linkToProcedure?.apiValue
                    }
                  />
                ) : (
                  <CustomTextField
                    name="discountValue"
                    fullWidth
                    handleChange={(e) =>
                      onChangeItemValue("discountValue", e?.target?.value)
                    }
                    value={itemValues?.discountValue}
                    type="number"
                    error={getTaxDiscountAndTotal(itemValues)?.isHigherDiscount}
                    helperText={
                      getTaxDiscountAndTotal(itemValues)?.isHigherDiscount
                        ? "Discount cannot be greater than unit price"
                        : ""
                    }
                    disabled={
                      activeTab === "Treatment" &&
                      itemValues?.linkToProcedure?.apiValue
                    }
                  />
                )}
              </Grid>
              <Grid item xs={6}>
                <Typography
                  sx={{
                    fontSize: "11px",
                    fontWeight: 700,
                    color: "#616161",
                    letterSpacing: "0.5px",
                    mb: 1,
                    textTransform: "uppercase",
                  }}
                >
                  DISCOUNT TYPE
                </Typography>
                <CustomSelect
                  list={dropDiscountTypes}
                  value={itemValues?.discountType}
                  handleChange={(e, value) => {
                    onChangeItemValue("discountType", value);
                  }}
                  search
                  disabled={
                    activeTab === "Treatment" &&
                    itemValues?.linkToProcedure?.apiValue
                  }
                />
              </Grid>
            </Grid>

            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              mb={1.5}
            >
              <Typography className="txt-semi-bold fs14 gray17">
                Discount
              </Typography>
              <Typography className="txt-semi-bold fs14 gray17">
                {Number(getTaxDiscountAndTotal(itemValues)?.discount) > 0
                  ? `Rs. ${Number(
                      getTaxDiscountAndTotal(itemValues)?.discount,
                    ).toFixed(2)}`
                  : "-"}
              </Typography>
            </Box>
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              mb={1.5}
            >
              <Typography className="txt-semi-bold fs14 gray17">Tax</Typography>
              <Typography className="txt-semi-bold fs14 gray17">
                {Number(getTaxDiscountAndTotal(itemValues)?.tax) > 0
                  ? `Rs. ${Number(
                      getTaxDiscountAndTotal(itemValues)?.tax,
                    ).toFixed(2)}`
                  : "-"}
              </Typography>
            </Box>
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              mb={1}
            >
              <Typography className="txt-semi-bold fs14 blue-color">
                Item Total
              </Typography>
              <Typography className="txt-semi-bold fs14 blue-color">
                {Number(getTaxDiscountAndTotal(itemValues)?.total) > 0
                  ? `Rs. ${Number(
                      getTaxDiscountAndTotal(itemValues)?.total,
                    )?.toFixed(2)}`
                  : "-"}
              </Typography>
            </Box>
          </Box>

          <Box
            display="flex"
            justifyContent="flex-end"
            alignItems="center"
            gap={1.5}
            px={3}
            py={2}
            borderTop="1px solid #e0e0e0"
            backgroundColor="#fafafa"
          >
            <CustomButton
              text="Add to bill"
              smallBtn
              disabled={isAddingItems}
              onClick={handleQueueAddItem}
            />
            <Button
              onClick={handleDoneAddItems}
              variant="outlined"
              disabled={isAddingItems}
              sx={{
                color: AppColors.appPrimary || "#0054A6",
                borderColor: AppColors.appPrimary || "#0054A6",
                textTransform: "none",
                fontWeight: 600,
                px: 2.5,
                height: "32px",
              }}
            >
              Done
            </Button>
          </Box>
        </Box>
      </CustomModal>

      <CustomModal
        open={disModVsble}
        onClose={onDiscountModClose}
        header="Apply Discount"
        rightModal
        modalWidth={30}
      >
        <Grid container spacing={0.5} className="ph20">
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <div className="txt-semi-bold fs14 selectypetext ">
              Discount Type
            </div>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <Checkbox
              radio
              onChange={(e) => onChangeDiscount("type", e?.target?.value)}
              radios={radioDiscountTypes}
              defaultValue={disValues?.type}
            />
          </Grid>
          {disValues?.type === "code" ? (
            <CustomSelect
              list={getDiscountCodes()}
              name="discountCode"
              value={disValues?.discountCode}
              handleChange={(e, value) =>
                onChangeDiscount("discountCode", value)
              }
              search
              error={!!disErrs?.discountCode}
              helperText={disErrs?.discountCode}
            />
          ) : (
            <CustomTextField
              label={`Discount  ${
                disValues?.type?.toLowerCase() === "price"
                  ? "Price"
                  : "Percentage"
              }`}
              name="amt"
              fullWidth
              handleChange={(e) => onChangeDiscount("amt", e?.target?.value)}
              value={disValues?.amt}
              labelTop
              type="number"
              error={!!disErrs?.amt}
              helperText={disErrs?.amt}
              mandatoryField
            />
          )}
          {(billDetails?.treatmentDiscountValue ?? 0) > 0 ? (
            <div
              className="flex-row-ali-cen cursor"
              onClick={() => handleAddDiscount(true)}
            >
              <Typography className="font-medium fs14 red-color mr5">
                Remove Discount
              </Typography>
              <CloseIcon
                sx={{
                  color: AppColors.red,
                  width: 15,
                  height: 15,
                  stroke: AppColors.red,
                  strokeWidth: 2,
                }}
              />
            </div>
          ) : null}
          <div className="flex1-end mt20">
            <div>
              <CustomButton
                text="Add"
                onClick={() => handleAddDiscount(false)}
                smallBtn
              />
            </div>
          </div>
        </Grid>
      </CustomModal>

      <CustomModal
        open={switchValues?.visible}
        onClose={() => onChange("visible", false)}
        header="Swich"
        modal
        modalWidth={20}
        headerBold
        headerShown={false}
      >
        <div className="ph10">
          <Typography className="fs16 font-bold blue-color flex-center">
            Switch
          </Typography>
          <div className="font-medium fs14 black2">Bill as</div>
          <CustomSelect
            list={billAsForBillingHistory}
            value={switchValues?.type}
            handleChange={(e) => onChange("type", e?.target?.value)}
            select
          />
          <div className="flex-row flex-center mv15">
            <div>
              <CustomButton text="Update" smallBtn onClick={onUpdateType} />
            </div>
            <div className="ml15">
              <CustomButton
                text="Cancel"
                smallBtn
                redBtn
                onClick={() => onChange("visible", false)}
              />
            </div>
          </div>
        </div>
      </CustomModal>

      <CustomModal
        open={delModVisible}
        onClose={handleDelModClose}
        header="Delete"
        modal
        modalWidth={30}
      >
        <Typography className="flex-center txt-regular fs14">
          {`Are you sure you want to ${selectedItem?.paymentDetailId ? "delete the item?" : "discard this record?"}`}
        </Typography>

        <div className="flex-center mb10 mt15">
          <div>
            <CustomButton text="Cancel" onClick={handleDelModClose} smallBtn />
          </div>
          <div className="ml10">
            <CustomButton
              redBtn
              text="Confirm"
              onClick={() => handleDelConfirm()}
              smallBtn
            />
          </div>
        </div>
      </CustomModal>
    </div>
  );
};

export default Billing;
